export default {
  "demo_account": {
    "footerpoint1": "Fxview adalah nama dagang dari grup perusahaan Fxview yang terdiri dari:",
    "footerpoint2": "- Perusahaan induk, Finvasia Securities Private Ltd, diatur oleh Dewan Sekuritas dan Bursa India (No Lisensi INZ000176037)",
    "footerpoint3": "- Charlgate Ltd, diatur oleh Komisi Sekuritas dan Bursa Siprus (Lisensi No 367/18)",
    "footerpoint4": "- Charlgate SVG LLC (Reg. No. 1112 LLC 2021) dengan alamat terdaftar di First Floor, First St Vincent Bank Ltd Building, James Street, Kingstown, Saint Vincent and the Grenadines.",
    "footerpoint5": "- Nevea Services Ltd (Reg. No. 422664) dengan alamat terdaftar di 319, 28th October Street, Kanika Business Center, Office 201B, Limassol 3105, Siprus.",
    "footerpoint6": "Perusahaan penjual adalah Nevea Services Ltd dengan alamat terdaftar di 319, 28 Oktober Street, Kanika Business Center, Office 201B, Limassol 3105, Siprus. Perusahaan penjual menyediakan konten, layanan administratif, pemrosesan pembayaran, dan layanan penyimpanan.",
    "footerpoint7": "Klien harus berusia minimal 18 tahun untuk menggunakan layanan Fxview.",
    "footerpoint8": "Trading instrumen kompleks dengan margin memiliki risiko tinggi dan mungkin tidak cocok untuk semua investor. Sebelum memutuskan untuk berdagang, Anda harus mempertimbangkan dengan cermat tujuan perdagangan, tingkat pengalaman, dan selera risiko Anda. Anda mungkin mengalami kerugian yang melebihi modal yang Anda investasikan, dan oleh karena itu Anda tidak boleh mendepositkan uang yang tidak mampu Anda tanggung. Pastikan Anda memahami sepenuhnya risiko dan berhati-hati dalam mengelolanya.",
    "footerpoint9": "Situs ini berisi tautan ke situs web yang dikendalikan atau ditawarkan oleh pihak ketiga. Fxview belum meninjau dan dengan ini melepaskan tanggung jawab atas informasi atau materi apa pun yang diposting di situs mana pun yang ditautkan ke situs ini. Dengan membuat tautan ke situs web pihak ketiga, Fxview tidak mendukung atau merekomendasikan produk atau layanan apa pun yang ditawarkan di situs web tersebut. Informasi yang terkandung di situs ini dimaksudkan untuk tujuan informasi saja. Oleh karena itu, tidak boleh dianggap sebagai penawaran atau ajakan kepada siapa pun di yurisdiksi mana pun di mana penawaran atau ajakan tersebut tidak diizinkan atau kepada siapa pun yang akan melanggar hukum untuk melakukan penawaran atau ajakan tersebut, juga tidak dianggap sebagai rekomendasi untuk membeli, menjual, atau berurusan dengan perdagangan tertentu. Jika Anda tidak yakin dengan peraturan perdagangan lokal Anda, maka Anda harus segera meninggalkan situs ini.",
    "footerpoint10": "Anda sangat disarankan untuk mendapatkan nasihat keuangan, hukum, dan pajak independen sebelum melanjutkan perdagangan apa pun. Tidak ada apa pun di situs ini yang dapat dibaca atau ditafsirkan sebagai saran dari Fxview atau afiliasi, direktur, pejabat, atau karyawannya.",
    "footerpoint11": "Layanan Fxview dan informasi di situs ini tidak ditujukan untuk penduduk Krimea, Kuba, Siprus, India, Iran, Korea Utara, Sudan, Suriah, dan Amerika Serikat dan tidak dimaksudkan untuk didistribusikan kepada, atau digunakan oleh, siapa pun di negara atau yurisdiksi mana pun di mana distribusi atau penggunaan semacam itu bertentangan dengan hukum atau peraturan setempat.",
    "high_risk_warning": "Peringatan Risiko Tinggi",
    "open_a": "Buka",
    "free_demo": "Demo Gratis",
    "account_on": "Akun",
    "mt4": "MetaTrader 4",
    "mt5": "MetaTrader 5",
    "act": "ActTrader",
    "or": "atau",
    "register": "Daftar",
    "login": "Masuk",
    "have_acc": "Punya akun?",
    "register_form_otp_msg": "Pin Sekali Pakai telah dikirim ke email Anda. Silakan masukkan di bawah ini.",
    "register_form_open_an_account": "Buka Akun",
    "register_form_will_take_minut": "Ini akan memakan waktu kurang dari satu menit",
    "register_form_select_residence_country": "Pilih Negara Tempat Tinggal",
    "register_form_email": "Alamat email",
    "register_form_pass": "Masukkan Kata Sandi",
    "register_form_cpass": "Konfirmasi Kata Sandi",
    "register_form_privacy_agree": "Dengan mendaftar, Anda menyetujui ketentuan",
    "register_form_privacy_policy": "Kebijakan Privasi",
    "website_use": "Penggunaan Situs Web",
    "cookies_policy": "Kebijakan Cookie",
    "refund_policy": "Kebijakan Pengembalian Dana",
    "AML_policy": "Kebijakan AML",
    "sub_heading1_our": "Kami",
    "sub_heading1_features": "Fitur",
    "sub_heading1_title": "Bebaskan potensi trading Anda dan taklukkan pasar dengan kondisi trading kami yang tak terkalahkan.",
    "sub_heading1_sub_container1_in_depth": "Mendalam",
    "sub_heading1_sub_container1_learning": "Pembelajaran",
    "sub_heading1_sub_container1_description": "Tingkatkan trading Anda dengan mendaftar ke webinar gratis kami dan belajar dari para ahli. Webinar kami dirancang khusus untuk meningkatkan pengetahuan pasar dan mengasah keterampilan trading Anda.",
    "sub_heading1_sub_container2_risk_free": "Bebas risiko",
    "sub_heading1_sub_container2_trading": "Perdagangan",
    "sub_heading1_sub_container2_description": "Apakah Anda baru mengenal trading atau sudah menjadi trader forex berpengalaman, temukan kehebatan trading Anda di Fxview, dengan akun demo forex bebas risiko.",
    "sub_heading1_sub_container3_hundreds_of": "Ratusan",
    "sub_heading1_sub_container3_tradable_instruments": "instrumen yang dapat diperdagangkan",
    "sub_heading1_sub_container3_description": "Dapatkan akses ke lebih dari 500 produk trading mulai dari Fx hingga Komoditas, Saham, Indeks, dan aset digital.",
    "sub_heading1_sub_container4_real_prices_with": "Harga nyata dengan",
    "sub_heading1_sub_container4_fast_execution": "eksekusi cepat",
    "sub_heading1_sub_container4_description": "Rasakan pengalaman trading real-time, jelajahi berbagai perangkat dan strategi, dan pertajam keahlian Anda sambil trading di akun demo yang sepenuhnya bebas risiko.",
    "sub_heading2_frequently_asked": "Pertanyaan yang Sering Diajukan",
    "sub_heading2_questions": "Pertanyaan",
    "sub_heading2_description": "Dapatkan Jawaban atas Pertanyaan Anda: Panduan Utama Anda.",
    "sub_heading2_more_info": "Info Lebih Lanjut",
    "sub_heading2_faq1_question": "Apakah ada batasan waktu untuk menggunakan akun demo?",
    "sub_heading2_faq1_answer": "Anda dapat menggunakan akun demo selama yang Anda inginkan. Akun hanya akan dinonaktifkan jika tidak ada aktivitas selama 30 hari berturut-turut.",
    "sub_heading2_faq2_question": "Dapatkah saya membuka beberapa akun demo dengan platform trading yang berbeda?",
    "sub_heading2_faq2_answer": "Ya, Anda bisa. Tidak ada batasan jumlah akun demo yang dapat dibuka dengan platform berbeda.",
    "sub_heading2_faq3_question": "Apa perbedaan antara akun trading demo dan live?",
    "sub_heading2_faq3_answer": "Akun trading live harus didanai dengan uang sungguhan untuk membuat trade. Sedangkan akun demo didanai dengan uang virtual untuk menghilangkan risiko kehilangan uang sungguhan. Selain itu, kondisi, alat, dan fitur perdagangan hampir sama untuk akun demo dan live.",
    "sub_heading2_faq4_question": "Berapa jumlah maksimum yang dapat saya perdagangkan di akun demo?",
    "sub_heading2_faq4_answer": "Anda akan mendapatkan $100.000 untuk trading di akun demo. Jumlah ini akan diisi ulang setelah saldo menjadi nol.",
    "sub_heading2_faq5_question": "Dapatkah saya berlatih trading CFD di akun demo?",
    "sub_heading2_faq5_answer": "Ya, Anda bebas memperdagangkan instrumen apa pun yang kami tawarkan untuk perdagangan langsung di akun demo Anda.",
    "sub_heading2_faq6_question": "Apakah saya bisa membuka beberapa akun demo?",
    "sub_heading2_faq6_answer": "Ya, Anda bisa membuka beberapa akun demo dengan platform berbeda. Namun, hanya satu akun demo yang dapat dibuka untuk setiap jenis akun.",
    "sub_heading2_faq7_question": "Apakah ada biaya ketidakaktifan di akun demo?",
    "sub_heading2_faq7_answer": "Tidak, kami tidak membebankan biaya ketidakaktifan, tetapi akun demo akan dinonaktifkan jika tidak digunakan selama 30 hari berturut-turut."
  },
  "financial_details": "Rincian Keuangan",
  "reg_step_one_point": "Jika dipekerjakan, sebutkan",
  "reg_step_one_point_two": "Perkiraan Pendapatan Tahunan (USD)",
  "reg_step_one_point_three": "Perkiraan Kekayaan Bersih (USD)",
  "reg_step_one_point_four": "Sumber Dana",
  "accountancy": "Akuntansi",
  "admin_secretarial": "Admin/Sekretaris",
  "auctions": "Lelang",
  "catering_hospitality": "Katering / Perhotelan",
  "creative_media": "Kreatif/Media",
  "education": "Pendidikan",
  "emergency_services": "Layanan Darurat",
  "engineering": "Teknik",
  "financial_services": "Jasa Keuangan",
  "gas_petrol": "Gas/Bensin",
  "health_medicine": "Kesehatan/Kedokteran",
  "army_industry": "Angkatan Darat / Industri Angkatan Darat",
  "hr": "SDM",
  "insurance": "Asuransi",
  "legal": "Hukum",
  "leisure_tourism": "Waktu luang/Pariwisata",
  "manufacturing": "Manufaktur",
  "marketing_pr_advertising": "Pemasaran/PR/Iklan",
  "pharmaceuticals": "Obat-obatan",
  "precious_metals_Diamonds": "Logam mulia / Berlian",
  "property_construction_real_state": "Konstruksi Properti / Real Estat",
  "retail": "Ritel",
  "sales": "Penjualan",
  "social_care_services": "Layanan Sosial/Pelayanan",
  "telecommunications": "Telekomunikasi",
  "transport_logistics": "Transportasi/Logistik",
  "trust_charities_foundations": "Perwalian / Amal / Yayasan",
  "virtual_currency": "Mata Uang Virtual",
  "other_please_specify": "Lainnya (Sebutkan)",
  "till_ten_thousand": "0-30,000",
  "till_fifty_thousand": "30,000-60,000",
  "till_one_lac": "60,000-100,000",
  "till_two_lac": "100,000-200,000",
  "above_two_lac": "Di atas 200.000",
  "zero_fiftythousand": "0-50,000",
  "till_fiftythousand": "50,000-100,000",
  "till_three_lac": "100,000-300,000",
  "above_three_lac": "300,000+",
  "employment": "Pekerjaan",
  "inheritance": "Warisan",
  "investment": "Investasi",
  "real_estate": "Real Estat",
  "savings": "Tabungan",
  "other": "Lainnya",
  "reg_step_three": "Mari uji pengalaman trading Anda",
  "reg_step_three_point": "Sebagai entitas teregulasi, kami diharuskan untuk menilai apakah Anda memiliki pemahaman yang tepat untuk memperdagangkan produk dengan leverage. Mohon lengkapi tes Kepatutan dengan hati-hati, karena jawaban Anda akan digunakan untuk menentukan apakah Anda dapat membuka akun trading Live bersama kami.",
  "start_test": "Mulai Tes",
  "depMsz1": "Waktu Pemrosesan:",
  "depMsz2": "1 hingga 5 hari kerja",
  "depMsz3": "Biaya:",
  "depMsz4": "0",
  "depMsz10": "Instan 24/7",
  "MiniDepositAmount": "Jumlah Setoran Minimum",
  "DntSkill": "Anda tidak memiliki id skrill, silakan",
  "depMsz12": "untuk mengubah ID Skrill Anda",
  "netId": "Id Netteller :",
  "depMsz13": "Bukan akun Neteller yang tepat? Silakan",
  "depMsz14": "Untuk mengubah ID Neteller Anda",
  "Clickhere": "Klik DI SINI.",
  "DntNetteler": "Anda tidak memiliki id netteller, silakan",
  "Tocreate": "untuk dibuat.",
  "conPay": "Konfirmasi Setoran",
  "depMsz15": "Harap pastikan bahwa detail deposit sudah benar. Jika Anda puas dengan semuanya, klik tombol 'Danai Sekarang' untuk melanjutkan. Harap diperhatikan bahwa jika Anda melakukan penarikan setelah melakukan deposit ke akun Anda, dana Anda kemungkinan besar akan dikembalikan ke metode yang sama dengan yang digunakan untuk melakukan deposit.",
  "accountId": "ID Akun",
  "feeUsd": "Biaya (USD)",
  "depositAmount": "Jumlah Setoran",
  "paymentMethod": "Metode Setoran",
  "backToStep": "Langkah sebelumnya",
  "procToPay": "Lanjutkan ke Pembayaran",
  "personalInfo": "Informasi Pribadi",
  "fname": "Nama depan",
  "lname": "Nama belakang",
  "InvalidNumber": "Nomor Telepon Tidak Valid",
  "saveContinue": "Simpan & Lanjutkan",
  "termsAgreeRqd": "Harap setujui persyaratan untuk melanjutkan",
  "googleOtp": "Masukkan kode sandi satu kali yang ditampilkan di aplikasi <strong>Google Authenticator</strong>.",
  "enterAmount": "Masukkan Jumlah",
  "allowDeposit1lac": "kami tidak mengizinkan deposit lebih dari 1.00.000 untuk akun demo",
  "SearchSomething": "Cari di sini",
  "search": "Pencarian",
  "Prev": "Sebelumnya",
  "Next": "Berikutnya",
  "PleaseEnsureCorrect": "Harap pastikan bahwa detailnya sudah benar",
  "lg_riskWarningMsg": "CFD adalah instrumen yang kompleks dan memiliki risiko tinggi kehilangan uang dengan cepat karena leverage. Sebagian besar akun klien ritel kehilangan uang saat berdagang CFD. Anda harus mempertimbangkan apakah Anda memahami cara kerja CFD dan apakah Anda mampu menanggung risiko tinggi kehilangan uang Anda.",
  "lg_welcomeMsgHeadone": "Ketentuan Perdagangan yang Kompetitif",
  "lg_welcomeMsg1": "Dapatkan manfaat dari spread serendah 0,0 pip pada pasangan mata uang utama, dan komisi $1 per $100.000 per sisi.",
  "lg_welcomeMsgHeadtwo": "Platform Kami",
  "lg_welcomeMsg2": "Akses pasar paling populer di dunia di platform kami yang cepat dan andal - MT4, MT5 & ActTrader",
  "lg_welcomeMsgHeadthree": "Alat Perdagangan",
  "lg_welcomeMsg3": "Akses berbagai perangkat trading seperti Autochartist, Trader's Tool Box, trading API, dan lainnya",
  "lg_signin": "Masuk ke Fxview",
  "lg_emailaddress": "Alamat email",
  "lg_EmailfieldValid": "Masukkan alamat email yang valid",
  "lg_EmailfieldReq": "Kolom Email wajib diisi",
  "lg_password": "Kata sandi",
  "lg_logIn": "Masuk",
  "lg_forgotPassword": "Lupa Kata Sandi",
  "lg_donthaveaccount": "Belum memiliki akun?",
  "lg_signuphere": "Daftar di sini",
  "lg_charlgateMsGlobal": "Finvasia Capital South Africa (PTY) Ltd perusahaan yang terdaftar di Afrika Selatan dengan Nomor Perusahaan 2018/303451/07. Alamat Kantor Terdaftar adalah Lantai 3, 34 Whiteley Blvd, Melrose Arch, Birnam, 2196.",
  "lg_charlgateMsEurope": "Charlgate Ltd disahkan dan diatur oleh CySEC, dengan nomor lisensi 367/18 & nomor registrasi perusahaan 372060.",
  "lg_varify2step": "Verifikasi dua langkah",
  "lg_EnterAuthCode": "Masukkan Kode Otentikasi",
  "lg_submit": "Kirim",
  "lg_backLogin": "Kembali ke login",
  "lg_footerMsz2": "Modal Anda berisiko. Anda mungkin kehilangan semua modal yang diinvestasikan.",
  "lg_riskDisclaimer": "Penafian Risiko",
  "fp_forgotPasswordText": "Silakan masukkan alamat email Anda yang terdaftar di fxview agar kami dapat membantu Anda membuat kata sandi baru.",
  "fp_resetPassword": "Atur Ulang Kata Sandi",
  "fp_RESEND_EMAIL": "Kirim Ulang Email",
  "fp_backLogin": "Kembali ke halaman masuk",
  "fp_charlgateMsg": "Charlgate Ltd memiliki fxview.com.  Charlgate Ltd adalah perusahaan yang disahkan dan diatur oleh Komisi Sekuritas dan Bursa Siprus - CySEC (nomor Lisensi CySEC 367/18 & nomor registrasi perusahaan: 372060) dan Anggota Dana Kompensasi Investor (ICF).",
  "reg_welcomemsg1": "<h3>Spread</h3> dari 0,0 pip</p> <p>dari 0,0 pip</p>",
  "reg_welcomemsg2": "<h3>$1 per</h3> <p>Komisi Rp100 ribu</p>",
  "reg_welcomemsg3": "<h3>Berbagai Jenis</h3> Alat Perdagangan</p>",
  "reg_welcomemsg4": "<h3>Ultra</h3> Eksekusi Cepat</p>",
  "reg_welcomemsg5": "<h3>100%</h3> <p>Bonus Deposit",
  "reg_openacc": "Buka Akun",
  "reg_takeminute": "Ini akan memakan waktu kurang dari satu menit",
  "reg_selectacctype": "pilih jenis akun",
  "reg_selectcountry": "pilih negara tempat tinggal",
  "reg_Enterfname": "Masukkan Nama Depan",
  "reg_Entername": "Masukkan Nama Anda",
  "reg_Enterlname": "Masukkan Nama Belakang",
  "reg_Enteremail": "Masukkan Alamat Email",
  "reg_Enterpwd": "Masukkan Kata Sandi",
  "reg_passwordFieldReq": "Kolom kata sandi wajib diisi",
  "reg_passCharVal": "Kata sandi Anda harus terdiri dari setidaknya 6 karakter, dan mencakup setidaknya 1 angka, 1 karakter huruf besar, dan 1 karakter khusus (!@#$%^*)",
  "reg_conPassword": "Konfirmasi Kata Sandi",
  "reg_ConfpasswordReq": "Kolom konfirmasi kata sandi wajib diisi.",
  "reg_newConfFieldSame": "Kata sandi yang dimasukkan tidak cocok. Silakan coba lagi",
  "reg_captchaErr": "Captcha tidak valid",
  "reg_register": "Daftar",
  "reg_signagree": "Dengan mendaftar, Anda menyetujui ketentuan",
  "reg_privacyPolicy": " Kebijakan Privasi",
  "reg_haveAccount": "Punya akun?",
  "reg_login": "Masuk",
  "reg_registerMsz2": "Pin Sekali Pakai telah dikirim ke email Anda. Silakan masukkan di bawah ini.",
  "reg_enterOtp": "Masukkan OTP",
  "reg_submit": "Kirim",
  "reg_resendotp": "Kirim ulang OTP",
  "rp_passwordHashMsz2": "Kata sandi telah berhasil diubah. Klik",
  "rp_here": "Di sini",
  "rp_toLogin": "untuk masuk",
  "rp_otherWayHelp": "Cara lain untuk mendapatkan bantuan",
  "rp_chatWithUs": "Mengobrol dengan kami",
  "rp_or": "atau",
  "rp_callUs": "Hubungi kami",
  "prof_verified": "Terverifikasi",
  "prof_undrreview": "Permohonan Anda sedang ditinjau!",
  "prof_checkstatus": "Silakan periksa status tiket Anda",
  "prof_clickhere": "Klik Disini",
  "prof_completeRegister": "Pendaftaran Lengkap",
  "prof_basicDetail": "Informasi Dasar",
  "prof_addressDetail": "Info Alamat",
  "prof_paymentDetail": "Rincian Pembayaran",
  "prof_documents": "Dokumen",
  "prof_fname": "Nama depan",
  "prof_lname": "Nama belakang",
  "prof_DOB": "Tanggal lahir",
  "prof_phone": "Telepon",
  "prof_Member": "Anggota",
  "prof_companyname": "Nama Perusahaan",
  "prof_incorporationdate": "Tanggal pendirian",
  "prof_currency": "Mata uang",
  "prof_emailaddress": "Alamat email",
  "prof_PEP": "Orang yang Terpapar Secara Politis (Politically Exposed Person/PEP)",
  "prof_addressLine1": "Alamat tempat tinggal baris 1",
  "prof_addressLine2": "Alamat tempat tinggal baris 2",
  "prof_postCode": "Kode Pos",
  "prof_city": "Kota atau Kota",
  "prof_resCountry": "Negara Tempat Tinggal",
  "prof_bankName": "Nama Bank:",
  "prof_AccNumber": "Nomor Rekening:",
  "prof_Pending": "Tertunda",
  "prof_Disable": "Nonaktifkan",
  "prof_viewDetail": "lihat detail",
  "prof_paymentMethod": "Metode Setoran",
  "prof_AccountName": "Nama Akun",
  "prof_SwiftCode": "Kode Cepat/BIC/Kode Urut",
  "prof_IBAN": "IBAN",
  "prof_bankAdd": "Alamat Bank:",
  "prof_onlinePayId": "ID Pembayaran Online:",
  "prof_Change": "Perubahan",
  "prof_CreditCard": "Nomor Kartu Kredit:",
  "prof_ExpiryDate": "Tanggal Kedaluwarsa:",
  "prof_noBankDetail": "Tidak ada rincian bank",
  "prof_AddBank": "Tambahkan Bank",
  "prof_AddCard": "Tambahkan kartu kredit",
  "prof_noDocuments": "Tidak Ada Dokumen",
  "prof_disablecard": "Mohon nonaktifkan metode pembayaran kartu kredit saya, dengan informasi seperti yang diberikan di bawah ini:",
  "prof_creditcardno": "nomor kartu kredit : **** **** ****",
  "prof_bankpaymentmethod": "Mohon nonaktifkan metode pembayaran transfer bank saya, informasi seperti yang diberikan di bawah ini:",
  "prof_diablepaymentmethod": "Nonaktifkan Metode Pembayaran",
  "prof_addpeymentmethod": "Tambahkan Metode Pembayaran",
  "twoFA_faText": "Autentikasi Dua Faktor",
  "twoFA_alreadyEnabled": "Diaktifkan",
  "twoFA_setUp2FA": "Menyiapkan 2FA",
  "twoFA_clickToDisable": "Klik Untuk Menonaktifkan",
  "twoFA_clickToEnable": "Klik Untuk Mengaktifkan",
  "twoFA_enable2FaText": "Mengaktifkan Autentikasi Dua Faktor",
  "twoFA_accounntSafe3Steps": "Jadikan Akun Anda lebih aman dalam 3 langkah mudah:",
  "twoFA_downloaduthApp": "Unduh Aplikasi Authenticator",
  "twoFA_downloaduthAppText": "Unduh dan instal Authy atau Google Authenticator ke ponsel atau tablet Anda.",
  "twoFA_scanQrCode": "Pindai Kode QR",
  "twoFA_scanQrCodeText": "Buka aplikasi autentikasi dan pindai gambar di sebelah kiri, menggunakan kamera ponsel Anda.",
  "twoFA_loginYourCode": "Masuk dengan Kode Anda",
  "twoFA_enter6DigitCode": "Masukkan 6 digit kode verifikasi yang dihasilkan.",
  "twoFA_activate": "Aktifkan",
  "twoFA_enterOtpDisableQrCode": "Harap Masukkan OTP untuk Menonaktifkan Kode QR",
  "twoFA_disableCodeText": "Nonaktifkan Dengan Kode Anda",
  "cp_changePassword": "Ubah Kata Sandi",
  "cp_oldpwd": "Kata Sandi Lama",
  "cp_newPassword": "Kata Sandi Baru",
  "cp_conPassword": "Konfirmasi kata sandi",
  "cp_passCharval": "Kata sandi Anda harus terdiri dari minimal 6 karakter, maksimal 15 karakter, dan menyertakan minimal 1 angka, 1 karakter huruf besar, dan 1 karakter khusus (!@#$%^*)",
  "welcm_fewStepAway": "Anda hanya tinggal beberapa langkah lagi",
  "welcm_activateFxviewAccountNow": "Aktifkan Akun Fxview Anda Sekarang!",
  "welcm_setupFxViewAcc": "Siapkan akun fxview Anda",
  "welcm_modify": "Memodifikasi",
  "welcm_addFund": "Tambah Dana",
  "welcm_startTrading": "Mulai Berdagang",
  "welcm_welcomeFxView": "Selamat datang di Fxview!",
  "welcm_welFxviewCon": "Anda hampir siap untuk memulai trading. Lengkapi aplikasi akun trading Anda dan unggah dokumen identifikasi yang diperlukan.",
  "welcm_completeReg": "Pendaftaran Lengkap",
  "welcm_tryDemoAcc": "Coba Akun Demo",
  "welcm_tryDemoAccCon": "Coba platform trading kami - MT4, MT5, dan ActTrader - dan kembangkan keahlian trading CFD Anda. Berlatih trading dengan dana virtual",
  "welcm_createDemoAccount": "Akun Demo",
  "welcm_downloadPlatform": "Unduh Platform",
  "welcm_MT4": "Meta Trader 4",
  "welcm_winIosAndroid": "Windows / iOS / Android",
  "welcm_MT5": "Meta Trader 5",
  "welcm_actTrader": "ActTrader<sup>TM</sup>",
  "welcm_rangeTradTools": "Rangkaian Alat Perdagangan",
  "welcm_wlcmMsz1": "Identifikasi ide trading yang dihasilkan secara otomatis berdasarkan pola grafik, breakout, pembalikan tren, pola Fibonacci, dan indikator teknikal.",
  "welcm_wlcmMsz2": "Jelajahi berbagai ide perdagangan yang dapat ditindaklanjuti yang dikenali berdasarkan berbagai pola grafik dan indikator teknis di berbagai kelas aset.",
  "welcm_wlcmMsz3": "Tetap selangkah lebih maju dengan berita keuangan real time dan pembaruan peristiwa geo-politik untuk membuat keputusan trading yang tepat.",
  "welcm_wlcmMsz4": "Dapatkan informasi terkini tentang kalender Ekonomi waktu nyata yang mencakup peristiwa dan indikator ekonomi global utama yang akan datang.",
  "welcm_wlcmMsz5": "Dapatkan pengalaman trading tak tertandingi melalui program hosting VPS yang sesuai yang memungkinkan Anda untuk trading tanpa gangguan dengan latensi yang lebih rendah.",
  "welcm_SeeMore": "Lihat Lebih Lanjut",
  "notif_Notification": "Pemberitahuan",
  "notif_noNewNotification": "Tidak Ada Pemberitahuan Baru",
  "verf_reqProcessing": "pemrosesan permintaan...",
  "verf_reqVerify": "Minta Verifikasi",
  "verf_dear": "Yang terhormat",
  "verf_requestVerifyWith": "Permintaan penarikan dana Anda telah berhasil diproses",
  "verf_backWithList": "Kembali ke Daftar Penarikan Dana",
  "verf_reqFailed": "Permintaan Gagal",
  "verf_msg": "Permintaan penarikan dana Anda gagal",
  "refer_Refera": "Merujuk",
  "refer_friend": "Teman",
  "refer_opportunity": "Program refer a friend kami memberi Anda kesempatan untuk mendapatkan $20 untuk setiap teman yang Anda referensikan. Selain itu, teman Anda juga akan mendapatkan $20 ketika mereka mendaftar dengan email undangan Anda.",
  "refer_Refernow": "Rujuk Sekarang",
  "refer_howorks": "Bagaimana cara kerjanya",
  "refer_everyclient": "Untuk setiap klien yang Anda referensikan, kami akan memberi Anda $20. Bagikan hal-hal favorit Anda tentang fxview dengan teman-teman Anda dan nikmati margin trading tambahan, bersama kami.",
  "refer_stepmsg1": "Daftar atau masuk ke akun fxview Anda",
  "refer_stepmsg2": "Undang teman Anda menggunakan formulir di area klien",
  "refer_stepmsg3": "Teman Anda akan menerima undangan melalui email dan mengikuti langkah-langkah untuk mendaftar",
  "refer_stepmsg4": "Anda dan teman Anda akan menerima $20 setelah Anda dan teman Anda mendanai akun mereka dengan $200 atau lebih",
  "refer_referEmail": "Email yang Dirujuk",
  "refer_addmore": "Tambahkan lagi",
  "refer_nowrefer": "lihat sekarang",
  "refer_successRefer": "Anda telah Berhasil Mereferensikan",
  "refer_refrMore": "Rujuk Lebih Lanjut",
  "refer_godashboard": "Buka Dasbor",
  "refer_partnerprog": "Program kemitraan kami yang lain",
  "refer_Affilialte": "Program Afiliasi",
  "refer_uniquelink": "Dapatkan tautan rujukan unik Anda",
  "refer_trackearn": "Lacak penghasilan Anda dari referensi",
  "refer_monitorStatus": "Pantau status rujukan Anda",
  "refer_withdrawearn": "Tarik penghasilan Anda sesuai keinginan Anda",
  "refer_register": "Daftar",
  "refer_knowmore": "Ketahui Lebih Lanjut",
  "refer_brokerprogram": "Program Introducing Broker",
  "refer_uniqueIB": "Portal IB yang unik",
  "refer_IBmanager": "Manajer IB yang berdedikasi",
  "refer_controlearn": "Kendalikan penghasilan Anda",
  "refer_regislink": "tautan pendaftaran IB yang unik",
  "refer_clientlist": "Daftar Klien",
  "refer_email": "Email",
  "refer_accountStatus": "Tahap Akun",
  "refer_volumereq": "Persyaratan volume",
  "refer_tradedvol": "Volume yang Diperdagangkan",
  "refer_qualified": "Berkualitas",
  "refer_action": "Tindakan",
  "refer_successDelete": "Anda Berhasil Menghapus",
  "refer_fromReflist": "dari daftar Referral Anda",
  "refer_wantTodelete": "Apakah Anda ingin menghapus",
  "refer_confrm": "Konfirmasi",
  "refer_enterEmailrefer": "Silakan Masukkan Email untuk merujuk",
  "refer_error": "kesalahan",
  "refer_errorReferal": "Anda harus diverifikasi dan didanai sebelum melakukan rujukan.",
  "dash_overview": "Ikhtisar",
  "dash_traderRoom": "Ruang Trader",
  "dash_personalInfo": "Informasi Pribadi",
  "dash_declaration": "Deklarasi",
  "dash_uploadDocumen": "Unggah Dokumen Pribadi",
  "dash_completeReg": "Pendaftaran Lengkap",
  "dash_checkticketstatus": "Silakan periksa status tiket Anda.",
  "dash_clickhere": "Klik Disini",
  "dash_TradingAcc": "Akun Perdagangan",
  "dash_live": "Langsung",
  "dash_demo": "Demo",
  "dash_Platform": "Platform",
  "dash_tradAccId": "ID Akun",
  "dash_Leverage": "Leverage",
  "dash_currency": "Mata uang",
  "dash_marketSummary": "Ringkasan Pasar",
  "dash_marketInsight": "Wawasan Pasar",
  "dash_news": "Berita",
  "dash_EconomicCal": "Kalender Ekonomi",
  "dash_thereIsNoRecord": "Tidak ada catatan yang ditemukan",
  "dash_Time": "Waktu",
  "dash_Country": "Negara",
  "dash_event": "Acara",
  "dash_frequency": "Frekuensi: Bulanan",
  "dash_autochartist": "AutoChartist",
  "dash_nodata": "Tidak ada data",
  "dash_time": "Waktu",
  "dash_impact": "Dampak",
  "dash_actual": "Sebenarnya",
  "dash_forecast": "Perkiraan",
  "dash_previous": "Sebelumnya",
  "dp_download": "Unduh",
  "dp_actTrader": "ActTrader<sup>TM</sup>",
  "dp_forWindows": "Untuk Windows",
  "dp_forIos": "Untuk iOS",
  "dp_forAndroid": "Untuk Android",
  "dp_ActWebTrader": "Bertindak Web Trader",
  "dp_MT4WebTrader": "Trader Web MT4",
  "dp_forMAC": "Untuk MAC",
  "dp_MT5WebTrader": "Trader Web MT5",
  "forWindows": "Windows",
  "forIos": "iOS",
  "WEB": "Web",
  "acc_Aclist": "Daftar Akun",
  "acc_changeLeverage": "Ubah Leverage",
  "acc_changeplatPass": "Ubah Kata Sandi Platform",
  "acc_InternalTrans": "Transfer Internal",
  "bnk_bankDetails": "Detail Bank",
  "bnk_MicrCode": "Kode Micr:",
  "bnk_IBANNumber": "Nomor Rekening IBAN",
  "bnk_ifscSwiftBic": "ifsc/Swift/Bic (Kode pendek untuk Inggris)",
  "bnk_Save": "Simpan",
  "db_requestBon": "Minta Bonus",
  "db_removeBon": "Hapus Bonus",
  "db_bonusList": "Daftar Bonus",
  "bver_bonusVerMsz1": "Permintaan bonus Anda telah berhasil diproses.",
  "bver_backBonusList": "Kembali ke Daftar Bonus",
  "bver_reqFailed": "Permintaan Gagal",
  "bl_bonusList": "Daftar Bonus",
  "bl_created": "Tanggal",
  "bl_amount": "Jumlah",
  "bl_bonusType": "Jenis Bonus",
  "bl_status": "Status",
  "bl_comments": "Komentar",
  "bl_complete": "Lengkap",
  "bl_pending": "Tertunda",
  "rb_removeBonus": "Hapus Bonus",
  "rb_removebonusMsz1": "Maaf, Anda tidak memenuhi syarat untuk menghapus bonus.",
  "rb_availbonus": "Bonus yang tersedia:",
  "rb_bonusremove": "Masukkan jumlah bonus yang akan dihapus",
  "rb_submit": "Kirim",
  "rb_googleAuth1": "Masukkan 6 digit Pin Sekali Pakai yang ditunjukkan pada bagian",
  "rb_googleAuth2": "Autentikator Google",
  "rb_googleAuth3": "aplikasi",
  "rb_validate": "Memvalidasi",
  "rb_googleAuth4": "Mengalami Masalah dengan Kode Autentikasi Dua Faktor Anda?",
  "rb_googleAuth5": "Klik Di Sini untuk melakukan verifikasi dengan Email",
  "rb_googleAuth6": "Kami telah mengirimkan tautan ke email Anda",
  "rb_bonusGoogleAuth": "Silakan klik tautan untuk melanjutkan penarikan dana Anda",
  "rb_googleAuth7": "Belum menerima email di kotak masuk atau folder spam? Kirim ulang",
  "rb_googleAuth8": "Autentikasi dua faktor tidak diaktifkan di akun Anda.",
  "rb_googleAuth9": "Autentikasi dua faktor menambahkan lapisan keamanan ekstra, memastikan bahwa benar-benar Anda yang mencoba membuat perubahan di akun fxview Anda.",
  "rb_googleAuth10": "Klik Di Sini untuk mengaktifkan autentikasi Google",
  "rb_congo": "Selamat.",
  "rb_removeBonusCongoMsz": "Bonus telah berhasil dihapus untuk Id Perdagangan",
  "rb_goToDash": "Buka dasbor",
  "rb_noTradingAccFound": "Tidak Ditemukan Akun Trading Live!",
  "rb_plzWaitWhileProc": "Mohon tunggu sementara kami memproses data Anda...",
  "rb_bonusGooglerequest": "Silakan klik tautan tersebut untuk melanjutkan permintaan bonus Anda",
  "rb_bonusGoogleremove": "Silakan klik tautan untuk melanjutkan",
  "req_bonus": "Bonus",
  "req_bonusMsz1": "Maaf, Anda tidak memenuhi syarat. Danai akun Anda untuk mendapatkan bonus.",
  "req_allowMaxBonus": "Bonus maksimum yang diizinkan",
  "req_amount": "Jumlah",
  "req_agreeTerms": "Saya setuju dengan syarat dan ketentuan",
  "reg_Agreee": "Saya setuju dengan ketentuan",
  "reg_TERMS": "syarat dan ketentuan",
  "req_fieldReq": "Bidang harus diisi",
  "req_maxlev": "Leverage maksimum yang diperbolehkan untuk memanfaatkan bonus deposit 100% adalah 300X.",
  "req_tochangeleverage": "untuk mengubah leverage Anda",
  "req_bonusMsz2": "Bonus telah berhasil ditambahkan untuk ID Trading:",
  "req_availBonus": "Gunakan Bonus",
  "req_allowBonus": "Bonus yang Diizinkan",
  "req_goBackMangeAcc": "Buka Kelola Akun",
  "req_noTradingAccFound": "Tidak Ditemukan Akun Trading Live!",
  "req_minBonus": "bonus setoran minimum adalah 200 dolar dan kami mendapatkan opsi untuk menyetor adalah",
  "req_maxAmount": "Jumlah maksimum yang dapat Anda minta untuk bonus adalah",
  "rb_ReadPolicy": "Baca Kebijakan Bonus Kami",
  "dep_acc_fund_depFundAcc": "Setor Dana ke Rekening",
  "dep_acc_fund_tradAccId": "ID Akun Perdagangan",
  "dep_acc_fund_depFund": "Dana Deposito",
  "dep_acc_fund_selDepMet": "Pilih Metode Deposit",
  "dep_acc_fund_depFieldReq": "Kolom DepositMethod wajib diisi",
  "dep_selectbankaccount": "Silakan Pilih Rekening Bank:",
  "dep_acc_fund_lessDet": "Kurang Detail",
  "dep_acc_fund_viewDet": "Lihat Detail",
  "dep_holderName": "Nama Pemegang:",
  "dep_sortCode": "Sortir Kode",
  "dep_reference": "Referensi",
  "dep_fortradaccount": "Untuk akun perdagangan",
  "dep_selectAcc": "Silakan Pilih Akun",
  "dep_acc_fund_DontbankAcc": "Anda tidak memiliki rekening bank apa pun, silakan",
  "dep_acc_fund_clkHere": "Klik Disini",
  "dep_Createbank": "untuk membuat bank baru",
  "dep_acc_fund_MinDepAmt": "Jumlah Setoran Minimum",
  "dep_acc_fund_SpeDepAm": "Tentukan jumlah setoran",
  "dep_mindepositallow": "Setoran minimum yang diperbolehkan",
  "dep_acc_fund_bakStp": "Langkah sebelumnya",
  "dep_acc_fund_procToPay": "Lanjutkan ke Pembayaran",
  "dep_ticketHasbeenCreated": "Tiket Anda telah dibuat",
  "dep_proMsz19": "Pergi ke Tiket",
  "dep_acc_fund_PlsEnsCort": "Harap pastikan bahwa detailnya sudah benar",
  "dep_acc_fund_accountId": "ID Rekening/Nomor Dompet",
  "dep_acc_fund_feeUsd": "Biaya (USD)",
  "dep_acc_fund_depAmt": "Jumlah Setoran",
  "dep_acc_fund_depMeth": "Metode Setoran",
  "dep_acc_fund_noTrdAccFnd": "Tidak Ditemukan Akun Trading Live!",
  "dep_acc_fund_plzWaitWhileProc": "Mohon tunggu sementara kami memproses data Anda...",
  "dep_maxlimit": "Anda telah menaikkan batas maksimum transaksi per bulan",
  "dep_maxdeposit": "Anda dapat menyetor jumlah maksimum =",
  "dep_pleaseDeposit": "Saya ingin menyetor",
  "dep_pleaseDeposit1": "dari detail bank seperti yang disebutkan di bawah ini <br>",
  "dep_AccNumber": "Nomor Rekening :",
  "dep_holdername": "<br> Nama Pemegang :",
  "dep_bankname": "<br> Nama Bank :",
  "dep_brsortCode": "<br> Kode Urutkan :",
  "dep_brbankAdress": "<br> Alamat Bank :",
  "dep_depositDone": "setoran berhasil dilakukan",
  "dep_depositFail": "setoran gagal",
  "dl_depositList": "Daftar Setoran",
  "dl_transId": "Id Transaksi",
  "dl_status": "Status",
  "dl_Method": "Metode",
  "dl_type": "Jenis",
  "dl_created": "Tanggal",
  "dl_action": "Tindakan",
  "dt_depTransHist": "Riwayat Transaksi Deposito",
  "dt_payMeth": "Metode Pembayaran",
  "dt_clickToResolve": "klik untuk menyelesaikan",
  "dw_acc_fund_selDepMet": "Pilih Metode Deposit",
  "dw_acc_fund_depFieldReq": "Kolom DepositMethod wajib diisi",
  "dw_selectaccount": "Silakan Pilih Rekening Bank:",
  "dw_acc_fund_lessDet": "Kurang Detail",
  "dw_acc_fund_viewDet": "Lihat Detail",
  "dw_holderName": "Nama Pemegang:",
  "dw_bankName": "Nama Bank:",
  "dw_bankAdd": "Alamat Bank:",
  "dw_sortCode": "Sortir Kode",
  "dw_reference": "Referensi",
  "dw_fortradingAcc": "Untuk akun perdagangan",
  "dw_acc_fund_DontbankAcc": "Anda tidak memiliki rekening bank apa pun, silakan",
  "dw_Createbank": "untuk membuat bank baru",
  "dw_acc_fund_MinDepAmt": "Jumlah Setoran Minimum",
  "dw_acc_fund_SpeDepAm": "Tentukan jumlah setoran",
  "dw_acc_fund_PlsEnsCort": "Harap pastikan bahwa detailnya sudah benar",
  "dw_acc_fund_accountId": "ID Akun",
  "dw_acc_fund_feeUsd": "Biaya (USD)",
  "dw_acc_fund_depAmt": "Jumlah Setoran",
  "dw_acc_fund_depMeth": "Metode Setoran",
  "dw_proMsz19": "Pergi ke Tiket",
  "dw_acc_fund_plzWaitWhileProc": "Mohon tunggu sementara kami memproses data Anda...",
  "dw_bankCode": "<br> Kode Bank :",
  "acc_reqProcessing": "pemrosesan permintaan...",
  "acc_accountVerMsz1": "permintaan telah berhasil diproses",
  "acc_backAccountList": "Kembali ke Daftar Akun",
  "acc_reqFailed": "Permintaan Gagal",
  "acclist_myAccounts": "Akun Saya",
  "acclist_liveAccount": "Akun Live",
  "acclist_demoAccount": "Akun Demo",
  "lev_changeLeverage": "Ubah Leverage",
  "lev_exsistLev": "Leverage yang ada",
  "lev_newLev": "Leverage Baru",
  "lev_backManageAccount": "Kembali ke Kelola Akun",
  "lev_levMsz1": "Silakan klik tautan untuk mengubah leverage Anda.",
  "lev_levMsz2": "Leverage akun trading Anda telah berhasil diubah",
  "lev_tradingId": "Ide Perdagangan",
  "lev_oldLev": "Leverage Lama",
  "lev_goBackMangeAccv": "Buka Kelola Akun",
  "lev_noDemoLiveTradingAccFound": "Akun Trading Tidak Ditemukan!",
  "lev_waitforVerf": "Mohon tunggu Verifikasi.",
  "levPwd_passMsz1": "Silakan klik tautan untuk mengubah kata sandi Anda",
  "lePwd_passMsz2": "Kata sandi akun trading Anda telah berhasil diubah",
  "lePwd_oldPassword": "Kata Sandi Lama",
  "Dlist_demoLive": "Demo / Live",
  "Dlist_accountType": "Jenis Akun",
  "Dlist_leverage": "Leverage",
  "detch_detachaccount": "Lepaskan akun:",
  "detch_fourfive": "454579",
  "detch_pamMaster": "Pamm master:",
  "detch_todd": "Todd Anderson",
  "detch_balance": "Keseimbangan",
  "detch_equity": "Ekuitas",
  "detch_freeMargin": "Margin Bebas",
  "detch_MarginUSed": "Margin yang Digunakan",
  "detch_pnl": "PnL",
  "detch_two": "$2000",
  "detch_eight": "$800",
  "detch_twelve": "$1200",
  "detch_three": "$300",
  "detch_twofive": "$-250",
  "detch_takenote": "Harap perhatikan poin-poin di bawah ini",
  "detch_openPosition": "Semua posisi terbuka akan ditutup sebelum melepaskan akun.",
  "detch_finalPnl": "PnL akhir dapat bervariasi sesuai dengan kondisi pasar.",
  "detch_afterOpen": "Setelah posisi terbuka ditutup, Biaya Manajemen, Biaya Berlangganan, Biaya Kinerja akan dihitung dan dipotong dari akun, jika ada.",
  "detch_terms": "Saya menerima syarat dan ketentuan di atas",
  "detch_confirm": "Konfirmasi",
  "It_oneRecord": "Anda hanya memiliki satu catatan. Harap buat setidaknya satu akun trading atau wallet lagi sebelum mencoba transfer internal",
  "It_liveAcc": "Akun Live",
  "It_wallet": "Dompet",
  "It_internalTransfer": "Transfer Internal",
  "It_confToTransfer": "Mohon Konfirmasi untuk Melanjutkan",
  "It_back": "Kembali",
  "It_freeMargin": "Margin Bebas",
  "It_interTransSorryMsz": "Maaf, Anda tidak memiliki saldo untuk mentransfer dana ke akun trading lain.",
  "It_transToAcc": "transfer ke nomor rekening",
  "It_fieldReq": "Bidang harus diisi",
  "It_currentBalance": "Saldo Saat Ini",
  "It_pleseEnterAmount": "silakan masukkan jumlah",
  "It_submit": "Kirim",
  "It_intTransMsz2": "Silakan klik tautan untuk mengonfirmasi transfer internal Anda",
  "It_intTransMsz3": "Transfer telah berhasil diselesaikan",
  "It_fromTradId": "Dari ID Perdagangan",
  "It_towallet": "Ke Dompet",
  "It_toTradId": "Ke ID Perdagangan",
  "It_transferAmount": "Jumlah yang ditransfer",
  "It_backinternalTrans": "Kembali ke transfer internal",
  "It_interTransDeducted": "akan dipotong dari",
  "It_depostotradAcc": "akan disetorkan ke akun Anda",
  "Itwallet_backwallet": "Kembali ke dompet",
  "Itwallet_cancel": "Batal",
  "Itwallet_fromwal": "dari dompet",
  "Itwallet_towal": "Ke Dompet",
  "Itwallet_backtowallet": "Kembali ke dompet",
  "sub_SubliveAcc": "Berlangganan Akun Langsung",
  "sub_subscribe": "Berlangganan",
  "sub_backtradingTool": "Kembali ke kotak alat bantu perdagangan",
  "sub_enterotp": "Masukkan Otp",
  "sub_validate": "Memvalidasi",
  "sub_resendOtp": "Kirim Ulang Otp",
  "sub_congo": "Selamat.",
  "sub_tradingId": "ID Perdagangan",
  "sub_addtradertool": "Silakan Tambahkan Kotak Alat Trader sesuai detail berikut <br> account_id :",
  "re_marketinsight": "Wawasan Pasar",
  "re_news": "Berita",
  "edu_learnTrade": "Belajar Trading",
  "edu_offerEdu": "Kami menawarkan sumber daya edukasi untuk mempelajari semua hal tentang trading. Materi pembelajaran kami memenuhi semua tingkat pengetahuan, dan memungkinkan Anda untuk meningkatkan pemahaman Anda tentang pasar global, trading online, dan perangkat trading kami. Daftar topik trading kami yang lengkap mulai dari yang dasar hingga yang mahir, dan akan membantu Anda meningkatkan trading Anda ke level yang lebih tinggi.",
  "edu_Enhance": "Tingkatkan pemahaman Anda tentang pasar global dan tingkatkan trading Anda ke level berikutnya dengan memanfaatkan sumber daya edukasi kami. Edukasi Fxview menawarkan daftar topik yang luas yang melayani semua tingkat trader - dari pemula hingga mahir - dan mencakup cara kerja pasar, serta cara menggunakan alat trading kami untuk keuntungan Anda.",
  "edu_tradeconfidence": "Anda akan belajar berdagang dengan percaya diri dengan berfokus pada aspek teknis dan fundamental dari perdagangan/investasi dengan bantuan dan dukungan kami selama",
  "edu_basic": "Dasar",
  "edu_advance": "Lanjutan",
  "edu_general": "Umum",
  "edu_forex": "Forex",
  "edu_commodities": "Komoditas",
  "edu_indices": "Indeks",
  "edu_stocks": "Saham",
  "edu_thereIsNoRecord": "Tidak ada catatan yang ditemukan",
  "marin_source": "Sumber: hoopsAI",
  "marin_loadmore": "Muat Lebih Banyak",
  "marin_loadwait": "Memuat mohon Tunggu...",
  "news_marketnews": "Berita Pasar",
  "news_fearurednews": "Berita Pilihan",
  "news_market": "Pasar",
  "news_nodata": "Tidak ada data",
  "news_latestnews": "Berita Terbaru",
  "video_video": "Video",
  "video_tut": "Tutorial",
  "video_intrestedforex": "Tertarik dengan trading forex? Anda berada di tempat yang tepat. Fxview menawarkan serangkaian tutorial video untuk membantu Anda mengembangkan keterampilan dan belajar trading seperti para profesional. Panduan langkah demi langkah kami mencakup instruksi tentang pendaftaran, verifikasi akun, terminologi forex dasar, fungsionalitas platform trading, dan banyak lagi.",
  "video_allvideo": "Semua Video",
  "video_fxviewtut": "Tutorial Fxview",
  "video_platTut": "Tutorial Platform",
  "video_forexBasic": "Dasar-dasar Forex",
  "video_whatisforex": "Apa itu forex",
  "web_webinars": "Webinar",
  "web_enhancetrad": "Tingkatkan trading Anda dengan mendaftar ke webinar gratis kami dan belajar dari para ahli. Webinar kami dirancang khusus untuk meningkatkan pengetahuan pasar dan mengasah keterampilan trading Anda. Para ahli mengungkapkan strategi dan konsep trading utama, yang dapat bermanfaat bagi trader pemula dan berpengalaman.",
  "web_registeran": "Mendaftar untuk",
  "web_upcomingweb": "webinar yang akan datang",
  "web_register": "Daftar",
  "web_timeleft": "Waktu tersisa",
  "web_days": "HARI",
  "web_hours": "JAM",
  "web_mins": "MENIT",
  "web_secs": "SECS",
  "web_webnar": "Webinar",
  "web_library": "perpustakaan",
  "web_higherpower": "Garis Tren-Webinar",
  "web_aprtwenty": "(9 Agustus 2021)",
  "web_findright": "Dukungan dan Perlawanan-Webinar",
  "web_aprsixteen": "(11 Agustus 2021)",
  "web_weekahead": "Indikator Dasar-Webinar",
  "web_aprtwelve": "(13 Agustus 2021)",
  "web_introTrend": "Pengantar Indikator Tren - Webinar",
  "web_apreighteen": "18 Maret",
  "web_topicdiscuss": "TOPIK DISKUSI",
  "web_correlation": "FXVIEW-Menggunakan Korelasi Untuk Meningkatkan Trading Anda",
  "web_datemay": "11 Mei 2021 12:00 - 12:40 siang GMT",
  "web_showlocal": "Tampilkan waktu lokal saya",
  "web_joinfxview": "Bergabunglah dengan pakar Fxview saat ia memberi Anda wawasan tentang penggunaan korelasi untuk meningkatkan keterampilan trading Anda.",
  "web_secureplace": "Amankan tempat Anda dengan pakar industri dan pelajari apa yang diperlukan untuk menjadi trader Forex profesional",
  "web_topicsCovered": "TOPIK YANG AKAN DIBAHAS SELAMA WEBINAR",
  "web_strongweak": "- Korelasi kuat vs lemah",
  "web_corrmultiple": "- Korelasi di berbagai kerangka waktu",
  "web_posneg": "- Memahami korelasi positif dan negatif",
  "ForexGlossarySpan": "Forex <span>Glosarium</span>",
  "ForexGlossaryGuide": "Glosarium forex Fxview adalah panduan lengkap untuk membantu Anda mempelajari terminologi forex dasar dan membiasakan diri dengan istilah-istilah trader.",
  "AGGREGATE_DEMAND": "PERMINTAAN AGREGAT",
  "text": "Ini adalah pengukuran ekonomi dari total permintaan untuk semua barang dan jasa jadi dalam suatu ekonomi/sektor. Hal ini menunjukkan bagaimana tingkat harga saat ini berhubungan dengan PDB riil suatu negara (Produk Domestik Bruto).",
  "APPRECIATION": "PENGHARGAAN",
  "AppText": "Ini mengacu pada peningkatan nilai satu mata uang terhadap mata uang lain sebagai respons terhadap permintaan pasar.",
  "ARBITRAGE": "ARBITRASE",
  "ArbText": "Pembelian aset keuangan di satu pasar dan penjualan bersamaan di pasar lain untuk mendapatkan keuntungan dari perbedaan harga dikenal sebagai arbitrase.",
  "AROUND": "SEKELILING",
  "ArndText": "Jargon dealer yang digunakan dalam mengutip ketika premi/diskon forward mendekati paritas. Contohnya, \"dua-dua di sekitar\" akan diterjemahkan menjadi 2 poin di kedua sisi dari titik saat ini.",
  "ASK_RATE": "TINGKAT PERTANYAAN",
  "Asktext": "Tingkat/harga di mana instrumen keuangan ditawarkan untuk dijual.",
  "ASSET_ALLOCATION": "ALOKASI ASET",
  "AsstText": "Strategi investasi yang bertujuan untuk menyeimbangkan risiko dan imbalan dengan mengalokasikan dana ke berbagai saham, obligasi, komoditas, mata uang, dan kelas aset lainnya sesuai dengan tujuan investor.",
  "Back_office": "Kantor pusat",
  "BalanceofTrade": "Neraca Perdagangan",
  "BarCharts": "Diagram Batang",
  "BaseCurrency": "Mata Uang Dasar",
  "BearMarket": "Pasar Beruang",
  "BidRate": "Nilai Tawaran",
  "btext1": "Departemen memeriksa semua penyelesaian dan proses terkait",
  "btext2": "Perbedaan nilai antara ekspor dan impor suatu negara.",
  "btext3": "Grafik batang digunakan di pasar keuangan untuk menyampaikan pergerakan harga ke dalam grafik yang mudah dibaca. Pada dasarnya, grafik ini adalah grafik grafis OHLC yang digunakan untuk memetakan harga. Ada tanda centang pada grafik yang menunjukkan harga dalam periode waktu tertentu pada saat pembukaan, tertinggi, terendah, dan penutupan.",
  "btext4": "Mata uang yang muncul dalam kuotasi pasangan forex. Selalu ada satu mata uang di pasar forex yang selalu dikuotasi dengan mata uang lainnya karena Anda membeli satu mata uang dan menjual mata uang lainnya. Mata uang dasar akan muncul pertama kali, diikuti oleh mata uang kedua (kuotasi). Misalnya, jika Anda melihat pasangan EUR/USD, di sini mata uang dasar adalah Euro dan mata uang pembanding adalah dolar AS.",
  "btext5": "Pasar yang ditandai dengan penurunan harga.",
  "btext6": "Harga maksimum yang bersedia dibayar oleh pembeli.",
  "CABLE": "KABEL",
  "CABLEText": "Julukan yang digunakan untuk pasangan GBP/USD. Istilah ini berasal dari fakta bahwa nilai tukar pada awalnya ditransmisikan melalui kabel transatlantik yang dimulai pada pertengahan tahun 1800-an, ketika GBP adalah mata uang perdagangan internasional.",
  "CANDLESTICK_CHART": "GRAFIK KANDIL",
  "CANDLESTICK_CHARTText": "Juga disebut grafik lilin Jepang, adalah jenis grafik batang yang pada dasarnya digunakan untuk menggambarkan pergerakan harga sekuritas, derivatif, atau mata uang. Setiap \"lilin\" biasanya menunjukkan satu hari dan mewakili perbedaan antara harga pembukaan dan penutupan. Jika harga pembukaan lebih tinggi dari harga penutupan, lilin/persegi panjang diarsir. Jika harga penutupan lebih tinggi dari harga pembukaan, maka area grafik tersebut tidak diarsir.",
  "CENTRAL_BANK": "BANK SENTRAL",
  "CENTRAL_BANKText": "Pemerintah atau organisasi kuasi pemerintah yang mengawasi kebijakan moneter suatu negara dan mencetak mata uang. Contohnya - Federal Reserve Bank (AS), Bank Sentral Eropa (Eropa), Reserve Bank of Australia (Australia).",
  "CHARTISTs": "CHARTIST",
  "CHARTISTsText": "Seseorang (juga dikenal sebagai trader teknikal) yang menggunakan chart dan grafik untuk menginterpretasikan data historis untuk menemukan tren dan memprediksi pergerakan harga di masa depan.",
  "CHOICE_MARKET": "PASAR PILIHAN",
  "CHOICE_MARKETText": "Juga disebut sebagai pasar terkunci, pasar tanpa spread. Artinya, mata uang dapat dibeli dengan harga yang sama dengan harga jual di pasar.",
  "CLEARING": "CLEARING",
  "CLEARINGtext": "Proses rekonsiliasi atau penyelesaian pembelian dan penjualan berbagai instrumen keuangan.",
  "CONTAGION": "KONTRA",
  "CONTAGIONText": "Kecenderungan krisis ekonomi menyebar dari satu pasar ke pasar lainnya.",
  "COLLATERAL": "KOLATERAL",
  "COLLATERALText": "Sesuatu yang diberikan oleh peminjam untuk mengamankan pinjaman atau sebagai jaminan kinerja.",
  "COMMISSIONs": "KOMISI",
  "COMMISSIONText": "Biaya transaksi yang dibebankan oleh broker dari trader/investor.",
  "CONFIRMATION": "KONFIRMASI",
  "CONFIRMATIONText": "Dokumen yang dipertukarkan oleh pihak-pihak yang bertransaksi yang menyatakan persyaratan transaksi tersebut.",
  "CONTRACTunit": "KONTRAK (unit atau lot)",
  "CONTRACTunitText": "Unit standar perdagangan.",
  "COUNTERPARTY": "PIHAK BERLAWAN",
  "COUNTERPARTYText": "Salah satu peserta, baik bank atau nasabah, yang melakukan transaksi keuangan.",
  "COUNTRY_RISK": "RISIKO NEGARA",
  "COUNTRY_RISKText": "Risiko yang terkait dengan transaksi lintas negara seperti kondisi hukum dan politik seperti perang.",
  "CROSS_RATES": "NILAI TUKAR",
  "CROSS_RATESText": "Nilai tukar antara dua mata uang yang tidak melibatkan Dolar AS. Kurs silang dikatakan tidak standar di negara tempat pasangan mata uang tersebut dikuotasi.",
  "CURRENCYe": "MATA UANG",
  "CURRENCYText": "Alat tukar dalam bentuk kertas, logam, atau digital yang diterbitkan oleh pemerintah/bank sentral dan digunakan sebagai alat pembayaran yang sah.",
  "CURRENCY_RISK": "RISIKO MATA UANG",
  "CURRENCY_RISKText": "Risiko mengalami kerugian akibat perubahan nilai tukar yang merugikan.",
  "Day_trading": "Perdagangan harian",
  "Day_tradingText": "Strategi trading yang melibatkan pembukaan dan penutupan posisi dalam satu hari yang sama.",
  "Dealer": "Dealer",
  "DealerText": "Seseorang yang bertindak sebagai prinsipal atau mitra dalam suatu transaksi. Prinsipal pada dasarnya berada di satu sisi dengan harapan mendapatkan keuntungan yang baik dengan menutup posisi dalam perdagangan berikutnya dengan pihak lain.",
  "Deficit": "Defisit",
  "DeficitText": "Suatu jumlah di mana biaya impor suatu negara melebihi biaya ekspornya atau juga disebut sebagai neraca perdagangan negatif.",
  "Delivery": "Pengiriman",
  "DeliveryText": "Penyelesaian transaksi dengan penyerahan dana. ATAU Tanggal jatuh tempo suatu kontrak, ketika penyelesaian akhir suatu transaksi dilakukan dengan menukarkan mata uang.",
  "Depreciation": "Penyusutan",
  "DepreciationText": "Penurunan nilai mata uang terhadap mata uang lain, baik karena kondisi pasar atau faktor lainnya.",
  "Derivative": "Turunan",
  "DerivativeText": "Derivatif mendapatkan nilainya dari harga aset acuan dan sering digunakan oleh trader sebagai instrumen untuk berspekulasi mengenai pergerakan harga aset di masa depan tanpa harus membeli aset itu sendiri. Opsi adalah instrumen derivatif yang paling umum.",
  "Devaluation": "Devaluasi",
  "DevaluationText": "Mata uang terdevaluasi ketika nilainya menurun terhadap satu atau lebih mata uang lainnya.",
  "ECONOMIC_INDICATOR": "INDIKATOR EKONOMI",
  "ECONOMIC_INDICATORText": "Ukuran statistik yang dikeluarkan oleh pemerintah atau lembaga non-pemerintah yang mengindikasikan kondisi ekonomi suatu negara seperti PDB, investasi asing, defisit perdagangan, tingkat ketenagakerjaan, dll.",
  "ENDOFDAYORDER": "PESANAN AKHIR HARI",
  "ENDOFDAYORDERText": "Perintah untuk membeli atau menjual pada harga tertentu yang hanya terbuka hingga akhir hari perdagangan, biasanya pukul 17:00/17:00 waktu New York.",
  "EUROs": "EURO",
  "EUROsText": "Mata uang Uni Moneter Eropa (EMU).",
  "EUROPEANCENTRALBANK": "BANK SENTRAL EROPA",
  "EUROPEANCENTRALBANKText": "Didirikan pada tahun 1998, bank ini merupakan Bank Sentral untuk European Monetary Union (EMU).",
  "FederalDepositInsurance": "Lembaga Penjamin Simpanan Federal (FDIC)",
  "FederalDepositInsuranceText": "Lembaga federal independen yang melindungi konsumen dan sistem keuangan AS. FDIC paling dikenal untuk asuransi deposito karena mereka membantu nasabah menghindari kerugian jika terjadi kegagalan bank.",
  "FederalReserveSystem": "Sistem Federal Reserve",
  "FederalReserveSystemText": "Institusi keuangan paling kuat di dunia. Federal Reserve System didirikan oleh kongres AS pada tahun 1913 dengan tujuan menyediakan sistem moneter yang stabil dan terdiri dari badan pemerintah pusat dan 12 bank sentral regional.",
  "FixedExchangeRate": "Nilai Tukar Tetap",
  "FixedExchangeRateText": "Rezim nilai tukar di mana nilai mata uang ditetapkan oleh otoritas moneter terhadap nilai satu atau lebih mata uang.",
  "FloatingExchangeRate": "Nilai Tukar Mengambang",
  "FloatingExchangeRateText": "Rezim nilai tukar di mana nilai mata uang ditetapkan oleh pasar valas berdasarkan permintaan dan penawaran relatif terhadap mata uang lainnya.",
  "Flatsquare": "Datar/persegi",
  "FlatsquareText": "Jargon dealer yang digunakan untuk menggambarkan posisi yang telah dibalik sepenuhnya. Contohnya, Anda membeli $100.000 kemudian menjual $100.000, sehingga menciptakan posisi flat.",
  "Foreign_Exchange": "Valuta Asing",
  "Foreign_ExchangeText": "Valuta Asing adalah pertukaran satu mata uang dengan mata uang lainnya. Ini adalah jaringan online global tempat para pedagang membeli dan menjual mata uang. Tidak memiliki lokasi fisik dan beroperasi 24 jam sehari.",
  "Forward": "Teruskan",
  "ForwardText": "Kurs yang telah ditentukan sebelumnya untuk mengunci harga pada waktu tertentu di masa depan, berdasarkan perbedaan suku bunga antara dua mata uang yang terlibat.",
  "Forward_Contracts": "Kontrak Forward",
  "Forward_ContractsText": "Perjanjian antara kedua belah pihak untuk membeli atau menjual suatu aset dengan harga tertentu pada tanggal kedaluwarsa yang telah ditentukan. Kedua belah pihak berkewajiban untuk memenuhi perjanjian pada akhir masa perjanjian.",
  "ForwardRates": "Kurs Forward (swap)",
  "ForwardRatesText": "Forward Rate adalah harga tunai dari selisih bunga 2 mata uang untuk periode tetap dan dapat dengan mudah dihitung asalkan suku bunga tetap dari setiap mata uang dan kurs spot saat ini diberikan.",
  "Forward_Trading": "Perdagangan Forward",
  "Forward_TradingText": "Perdagangan Forward adalah membuat perdagangan yang berlawanan dari perdagangan spot pada waktu tertentu. Trader sering menukar perdagangan mereka ke depan mulai dari seminggu hingga berbulan-bulan. Meskipun kontrak forward terjadi pada tanggal yang akan datang, namun posisi tersebut dapat ditutup kapan saja. Kemudian bagian penutupan posisi tersebut ditukar ke depan ke tanggal nilai masa depan yang sama.",
  "Forwardpoints": "Poin ke depan",
  "ForwardpointsText": "Cukup dengan pip yang ditambahkan atau dikurangi dari nilai tukar saat ini untuk menghitung harga forward.",
  "Fundamental_Analysis": "Analisis Fundamental",
  "Fundamental_AnalysisText": "Metode analisis faktor-faktor yang dapat memengaruhi harga di masa depan. Bentuk analisis ini didasarkan pada peristiwa dan pengaruh eksternal serta tren industri, di mana trader teknikal memperoleh informasi dari grafik dan pola.",
  "FuturesContract": "Kontrak Berjangka",
  "FuturesContractText": "Perjanjian hukum antara dua pihak untuk melakukan perdagangan dengan harga yang telah ditentukan, pada tanggal yang telah ditentukan di masa depan. Futures diperdagangkan melalui bursa dan dapat digunakan untuk mendapatkan eksposur ke berbagai aset.",
  "Gearing": "Gearing",
  "GearingText": "Ketika seorang trader berdagang dengan sebagian utang atau margin.",
  "GroupofFive": "Kelompok Lima (G5)",
  "GroupofFiveText": "Lima negara industri terkemuka - Perancis, Jepang, Inggris, Jerman dan Amerika Serikat yang bertemu dari waktu ke waktu dengan tujuan untuk mendiskusikan masalah-masalah ekonomi bersama.",
  "GroupofSeven": "Kelompok Tujuh (7)",
  "GroupofSevenText": "\"Kelompok Tujuh\" adalah 7 negara industri non-komunis terkemuka yang terdiri dari Perancis, Jerman, Inggris, Jerman dan AS ditambah Kanada dan Italia. Mereka sekarang dikenal sebagai G8 sejak bergabungnya Rusia.",
  "GroupofTen": "Kelompok Sepuluh (G10)",
  "GroupofTenText": "Juga disebut \"The Paris Club\" yang terdiri dari Kanada, Belgia, Perancis, Jerman, Italia, Swedia, Jepang, Inggris, Amerika Serikat, dan Belanda. Dibentuk pada tahun 1962 untuk menyediakan dana bagi IMF dan membantu negara-negara anggota yang mengalami kesulitan neraca pembayaran.",
  "GoldilocksEconomy": "Ekonomi Goldilocks",
  "GoldilocksEconomyText": "Istilah yang digunakan untuk menggambarkan ekonomi yang tidak terlalu panas atau terlalu dingin dan mempertahankan pertumbuhan moderat dengan tingkat inflasi nominal, yang memungkinkan kebijakan moneter yang ramah terhadap pasar.",
  "GoodtilCancel": "Baik sampai Dibatalkan (GTC)",
  "GoodtilCancelText": "Pesanan yang berlaku hingga dibatalkan atau diselesaikan terlepas dari jumlah waktu saat pesanan dilakukan.",
  "HEDGING": "HEDGING",
  "HEDGINGText": "Strategi manajemen risiko di mana investor melakukan 'lindung nilai' untuk melindungi diri dari pergerakan harga yang merugikan dengan mengambil dua posisi yang berlawanan dan dengan demikian mengurangi risiko. Dalam konteks transaksi mata uang, strategi ini akan melindungi seseorang dari fluktuasi nilai tukar valas.",
  "INFLATION": "INFLASI",
  "INFLATIONText": "Kenaikan harga barang konsumsi secara umum yang terus menerus, yang mengikis daya beli.",
  "INITIALMARGIN": "MARGIN AWAL",
  "INITIALMARGINText": "Setoran awal jaminan yang diperlukan untuk masuk ke dalam suatu posisi sebagai jaminan atas kinerja di masa depan.",
  "INTERBANKRATES": "SUKU BUNGA ANTAR BANK",
  "INTERBANKRATESText": "Kurs valuta asing yang digunakan oleh bank-bank internasional besar untuk mengutip bank-bank internasional besar lainnya.",
  "LEADINGINDICATORS": "INDIKATOR UTAMA",
  "LEADINGINDICATORSText": "Variabel ekonomi yang dipertimbangkan untuk memprediksi aktivitas ekonomi di masa depan.",
  "LEVERAGEs": "LEVERAGE",
  "LEVERAGEsText": "Leverage ditawarkan oleh broker untuk memaksimalkan daya beli trader. Ini dapat digambarkan sebagai 'modal pinjaman' dari sudut pandang pedagang dan meningkatkan potensi keuntungan Anda karena Anda dapat memperdagangkan volume yang jauh lebih besar dengan dana ini daripada modal Anda yang terbatas. Hal ini dinyatakan dalam rasio seperti 1:100, 1:300, dan seterusnya. Jadi dengan leverage 1:100, daya beli trader diperbesar 100 kali lipat. <strong>Disclaimer:</strong> Leverage memperbesar kemungkinan keuntungan dan kerugian.",
  "LIBOR": "LIBOR",
  "LIBORText": "Suku Bunga yang ditawarkan London Interbank. Ini adalah suku bunga acuan yang digunakan bank-bank besar dunia untuk meminjamkan uang kepada satu sama lain.",
  "LIMITORDER": "BATAS PESANAN",
  "LIMITORDERText": "Perintah untuk mengeksekusi perdagangan pada harga tertentu atau lebih baik. Contohnya, jika harga EUR/USD saat ini adalah 1.08502/1.08522, maka limit order untuk membeli EUR akan berada di harga di bawah harga pasar, yaitu 1.0820.",
  "LINECHARTS": "GARIS GARIS",
  "LINECHARTSText": "Grafik harga yang menghubungkan harga tunggal (semua harga penutupan) untuk periode waktu yang dipilih.",
  "LIQUIDITYs": "LIKUIDITAS",
  "LIQUIDITYsText": "Kemampuan pasangan mata uang untuk dibeli dan dijual di pasar tanpa menyebabkan perubahan signifikan pada nilai tukarnya.",
  "LIQUIDATION": "LIKUIDASI",
  "LIQUIDATIONText": "Penutupan posisi yang ada melalui eksekusi transaksi saling hapus.",
  "LONGPOSITION": "POSISI PANJANG",
  "LONGPOSITIONText": "Sebuah posisi dikatakan 'long' jika nilainya meningkat ketika harga pasar meningkat. Ketika seseorang membeli pasangan mata uang, posisinya adalah long pada pasangan mata uang tersebut.",
  "Margins": "Margin",
  "MarginText": "Margin adalah jumlah uang yang diperlukan untuk menjaga posisi margin tetap terbuka. Ini adalah selisih antara nilai penuh posisi Anda dan dana yang dipinjamkan kepada Anda oleh broker/penyedia leverage.",
  "MarginDeposit": "Setoran Margin",
  "MarginDepositText": "Deposit margin adalah jumlah uang awal yang harus diletakkan oleh trader untuk membuka posisi trading dengan leverage. Ini juga dapat dikenal sebagai margin awal, deposit, atau deposit.",
  "MarginCall": "Margin Call",
  "MarginCallText": "Margin call dapat digambarkan sebagai peringatan/permintaan/panggilan dari broker Anda untuk memberi tahu Anda bahwa margin pemeliharaan Anda telah jatuh di bawah minimum dan posisi Anda berisiko dilikuidasi. Jadi, dalam kasus seperti ini broker meminta klien untuk menambah akun mereka untuk mempertahankan posisi terbuka yang ada.",
  "MarketMaker": "Pembuat Pasar",
  "MarketMakerText": "Dealer yang mempertahankan harga penawaran dan permintaan yang pasti dan siap untuk membuat pasar dua sisi untuk instrumen keuangan apa pun.",
  "MarketRisk": "Risiko Pasar",
  "MarketRiskText": "Paparan terhadap perubahan harga pasar.",
  "Marktomarket": "Tandai ke pasar",
  "MarktomarketText": "Menyesuaikan/mengevaluasi semua posisi terbuka sesuai dengan harga pasar saat ini.",
  "Maturity": "Kedewasaan",
  "MaturityText": "Tanggal penyelesaian atau kadaluarsa dari suatu instrumen keuangan.",
  "NarrowMarket": "Pasar Sempit",
  "NarrowMarketText": "Pasar bursa juga dicirikan oleh Thin Market di mana jumlah pembeli dan penjual yang sedikit dan harga cenderung tidak stabil.",
  "Offer_s": "Penawaran",
  "OfferText": "Sama seperti harga permintaan, harga yang bersedia dijual oleh dealer.",
  "Offsettingtransaction": "Transaksi saling hapus",
  "OffsettingtransactionText": "Offsetting dapat berarti menutup posisi untuk membatalkan atau mengimbangi sebagian atau seluruh risiko pasar dari posisi terbuka.",
  "OneCancelsOrder": "Satu Membatalkan Pesanan Lainnya (OCO)",
  "OneCancelsOrderText": "Ketika Anda memasang stop order dan limit order dan jika salah satu dieksekusi, maka order yang lain secara otomatis akan dibatalkan.",
  "Openorder": "Buka pesanan",
  "OpenorderText": "Pesanan yang tidak memiliki tanggal kedaluwarsa tertentu dan dieksekusi ketika harga pasar tertentu tercapai. Order ini umumnya dikaitkan dengan order GTC.",
  "Open_position": "Posisi terbuka",
  "OpenPositionText": "Posisi yang masih aktif dan belum ditutup atau dibatalkan.",
  "OvertheCounter": "Di atas Meja (Over the Counter/OTC)",
  "OvertheCounterText": "Perdagangan OTC adalah untuk sekuritas perusahaan-perusahaan yang tidak terdaftar di bursa sentral mana pun, sehingga pembelian dan penjualan sekuritas semacam itu dilakukan di luar bursa, yaitu melalui pialang dan dealer swasta, yang secara langsung bernegosiasi dengan pembeli dan penjual.",
  "Overnight": "Semalam",
  "OvernightText": "Perdagangan/posisi yang tetap terbuka hingga hari kerja berikutnya.",
  "Pip_s": "Pips",
  "PipText": "Jumlah perubahan terkecil dalam kuotasi harga forex. Sebagian besar mata uang utama mendefinisikan pip sebagai angka desimal keempat, sehingga perubahan satu pip setara dengan 0,0001 kecuali Yen Jepang di mana pip adalah angka kedua setelah koma desimal.",
  "PoliticalRisk": "Risiko Politik",
  "PoliticalRiskText": "Perubahan atau ketidakstabilan dalam kebijakan pemerintah dapat berdampak buruk pada posisi/imbal hasil investor.",
  "PointFigureCharts": "Grafik Titik & Gambar",
  "PointFigureChartsText": "Grafik Titik & Angka tidak mempertimbangkan waktu dan sepenuhnya fokus pada pergerakan harga dan tren aset.",
  "Position_s": "Posisi",
  "PositionText": "Posisi adalah istilah keuangan untuk perdagangan yang saat ini aktif dan dapat menghasilkan kerugian/keuntungan yang disebut posisi terbuka atau perdagangan yang baru saja ditutup yang dikenal sebagai posisi tertutup.",
  "Premium": "Premium",
  "PremiumText": " Jumlah dimana harga masa depan atau harga forward melebihi harga spot.",
  "PriceTransparency": "Transparansi Harga",
  "PriceTransparencyText": " Menjelaskan kuotasi yang dapat diakses oleh setiap peserta pasar",
  "Quote_s": "Kutipan",
  "QuoteText": "Harga di mana aset terakhir kali diperdagangkan atau saat ini dapat dibeli atau dijual dan hanya digunakan sebagai informasi tambahan.",
  "RATE_s": "NILAI",
  "RATEText": "Harga satu mata uang terhadap mata uang lainnya, yang nilainya berubah relatif terhadap masing-masing mata uang dari waktu ke waktu.",
  "RESISTANCE_s": "RESISTENSI",
  "RESISTANCEText": "Istilah analisis teknikal yang umum digunakan yang menunjukkan tingkat harga tertentu di mana mata uang tidak dapat menyeberang. Harga tersebut bertindak sebagai batas atas.",
  "REVALUATION": "REVALUASI",
  "REVALUATIONText": "Kebalikan dari devaluasi, revaluasi adalah penyesuaian ke atas terhadap nilai tukar resmi suatu negara sebagai akibat dari intervensi bank sentral.",
  "REVALUATIONRATES": "TINGKAT REVALUASI",
  "REVALUATIONRATESText": "Ini adalah nilai pasar yang digunakan sebagai nilai dasar oleh para pedagang untuk menilai apakah keuntungan/kerugian telah direalisasikan untuk hari itu atau secara keseluruhan. Biasanya nilai revaluasi adalah nilai penutupan untuk hari perdagangan sebelumnya.",
  "RISK_s": "RISIKO",
  "RISKText": "Potensi hasil negatif seperti kinerja yang kurang baik, kegagalan untuk mencapai tujuan perdagangan/investasi atau kehilangan uang atau perubahan yang merugikan.",
  "RISKCAPITAL": "MODAL RISIKO",
  "RISKCAPITALText": "Jumlah uang yang dapat diinvestasikan oleh seseorang, yang kehilangannya tidak akan mengakibatkan perubahan substansial pada gaya hidup mereka.",
  "RISK_MANAGEMENT": "MANAJEMEN RISIKO",
  "RISKMANAGEMENTText": "Semua teknik dan strategi yang digunakan untuk mengurangi dan/atau mengendalikan risiko yang melekat dalam perdagangan dan investasi seperti menggunakan stop loss, lindung nilai, diversifikasi, dll.",
  "ROLLOVER": "ROLL OVER",
  "ROLLOVERText": "Ini adalah penutupan simultan dari posisi terbuka untuk tanggal nilai hari ini dan pembukaan posisi yang sama untuk tanggal nilai hari berikutnya dengan harga yang mencerminkan perbedaan suku bunga antara dua mata uang.",
  "ROLLOVERRATE": "TINGKAT ROLL OVER",
  "ROLLOVERRATEText": "Bunga yang dibayarkan atau diperoleh dalam semalam untuk memegang posisi, tergantung pada margin yang ditetapkan dan posisi di pasar.",
  "SETTLEMENT": "PENYELESAIAN",
  "SETTLEMENTText": "Pengalihan kepemilikan instrumen keuangan kepada pembeli. Penyelesaian perdagangan mata uang mungkin atau mungkin tidak melibatkan pertukaran fisik yang sebenarnya dari satu mata uang ke mata uang lainnya.",
  "SHORTPOSITION": "POSISI PENDEK",
  "SHORTPOSITIONText": "Posisi dikatakan short apabila trader menjual sekuritas terlebih dahulu dengan tujuan membelinya kembali saat harga turun. Posisi ini diambil saat trader yakin bahwa harga akan turun dalam waktu dekat.",
  "SLIPPAGE": "SLIPPAGE",
  "SLIPPAGEText": "Slippage terjadi ketika spread bid/ask berubah antara waktu ketika order diminta hingga waktu order dieksekusi. Hal ini biasanya terjadi selama periode volatilitas tinggi dan terjadi di semua pasar seperti ekuitas, obligasi, mata uang, dan kontrak berjangka.",
  "SPOTNEXT": "TEMPAT/BERIKUTNYA",
  "SPOTNEXTText": "Juga dikenal sebagai \"hari kerja berikutnya, ini menunjukkan pengiriman mata uang yang dibeli pada hari setelah tanggal spot. Swap ini merupakan swap jangka pendek di mana mata uang diluncurkan satu hari berikutnya, yaitu setelah spot.",
  "SPOTPRICE": "HARGA SPOT",
  "SPOTPRICEText": "Harga pasar saat ini dari suatu instrumen keuangan.",
  "SPOTRATE": "SPOT (TINGKAT)",
  "SPOTRATEText": "Nilai tukar saat ini di mana mata uang dapat dibeli atau dijual. Ini adalah nilai tukar yang dikutip di pasar ritel tanpa penyesuaian untuk perbedaan suku bunga.",
  "SPOTTRADE": "PERDAGANGAN SPOT",
  "SPOTTRADEText": "Transaksi ini mengacu pada pembelian dan penjualan produk keuangan untuk penyerahan seketika pada tanggal tertentu. Juga dikenal sebagai transaksi spot dan biasanya diselesaikan secara elektronik.",
  "Spread_s": "Penyebaran",
  "SpreadText": "Spread dalam trading berarti kisaran/perbedaan antara harga bid dan ask yang dikutip untuk pasangan mata uang.",
  "Sterling": "Sterling",
  "SterlingText": "Istilah untuk Pound Inggris.",
  "StopLossOrder": "Perintah Hentikan Kerugian (Stop Loss Order)",
  "StopLossOrderText": "Jenis order untuk menjual mata uang ketika harga mencapai atau jatuh di bawah harga yang ditentukan. Ini digunakan untuk membatasi kerugian, biasanya ketika harga tidak dapat dipantau secara aktif oleh trader.",
  "StochasticOscillator": "Osilator Stokastik",
  "StochasticOscillatorText": "Istilah Stochastic mengacu pada titik harga saat ini dalam kaitannya dengan kisaran harga selama periode waktu tertentu. Stochastic Oscillator adalah indikator analisis teknikal populer yang menyatakan bahwa selama pasar perdagangan naik, harga cenderung ditutup di dekat titik tertinggi dan sebaliknya.",
  "SupportLevels": "Tingkat Dukungan",
  "SupportLevelsTexts": " Istilah ini menunjukkan tingkat harga tertentu di mana mata uang tidak dapat melintas di bawahnya. Support terjadi ketika penurunan harga berhenti, berubah arah, dan mulai naik. Level support sering dipandang sebagai \"lantai\" yang mendukung atau menahan harga.",
  "Swap_s": "Tukar",
  "SwapText": "Swap adalah kontrak derivatif di mana dua pihak saling mempertukarkan arus kas atau kewajiban yang timbul dari dua instrumen keuangan yang berbeda.",
  "Swift": "Cepat",
  "SwiftText": "Masyarakat Telekomunikasi Keuangan Antar Bank di Seluruh Dunia. Ini menyediakan jaringan komputer khusus yang memungkinkan lembaga keuangan di seluruh dunia untuk mendukung pesan transfer dana dalam lingkungan yang aman, terstandardisasi, dan andal.",
  "TECHNICALANALYSIS": "ANALISIS TEKNIS",
  "TECHNICALANALYSISText": "Ini melibatkan penggunaan berbagai indikator teknis dan analisis aksi pasar melalui studi grafik, volume, tren, pola, rata-rata bergerak, dan berbagai indikator teknis lainnya dengan tujuan untuk memperkirakan harga.",
  "TICK_s": "CENTANG",
  "TICKText": "Tanda centang mewakili setiap penawaran harga yang akan datang, naik atau turun.  ",
  "TICKER": "TICKER",
  "TICKERText": "Ini menunjukkan riwayat mata uang saat ini atau baru-baru ini baik dalam format tabel atau grafik.",
  "TOMORROWNEXT": "BESOK SELANJUTNYA (TOM/NEXT)",
  "TOMORROWNEXTText": "Ini adalah pembelian dan penjualan mata uang secara simultan untuk penyerahan pada hari berikutnya.",
  "TRADING_s": "PERDAGANGAN",
  "TRADINGText": "Tindakan membeli, menjual, menukar saham, obligasi, atau mata uang, dll.",
  "TRANSACTIONCOST": "BIAYA TRANSAKSI",
  "TRANSACTIONCOSTText": "Biaya pembelian dan penjualan instrumen keuangan.",
  "TRANSACTIONDATE": "TANGGAL TRANSAKSI",
  "TRANSACTIONDATEText": "Tanggal terjadinya perdagangan.",
  "TREND_s": "TREN",
  "TRENDText": "Tren adalah kecenderungan harga untuk bergerak ke arah tertentu, naik/turun/mundur/samping. Tren biasanya dibagi menjadi tiga kategori - tren jangka panjang, menengah, dan pendek.",
  "TRENDLINE": "TRENDLINE",
  "TRENDLINEText": " Ini adalah indikator teknikal yang sangat umum digunakan untuk mengungkap tren. Garis tren menghubungkan dua atau lebih titik terendah atau titik tertinggi dengan garis yang diproyeksikan ke masa depan. Garis ini dihitung dengan menggunakan \"metode kuadrat terkecil\" dan juga disebut regresi linier.",
  "TURNOVER": "TURNOVER",
  "TURNOVERText": "Ini adalah total nilai uang dari semua transaksi yang dieksekusi dalam periode waktu tertentu.",
  "TWOWAYPRICE": "HARGA DUA CARA",
  "TWOWAYPRICEText": "Kuotasi dua arah menunjukkan harga penawaran saat ini dan harga permintaan saat ini dari suatu sekuritas pada hari perdagangan.",
  "UPTICK": "UPTICK",
  "UPTICKText": "Kenaikan terjadi ketika harga sekuritas naik sehubungan dengan tick terakhir. Ini adalah kuotasi harga baru dengan harga yang lebih tinggi dari kuotasi sebelumnya.",
  "UPTICKRULE": "ATURAN UPTICK",
  "UPTICKRULEText": "Pembatasan perdagangan di AS yang menyatakan bahwa short selling hanya diperbolehkan pada saat kenaikan. Sesuai aturan, sekuritas tidak boleh dijual pendek kecuali perdagangan terakhir sebelum penjualan pendek berada pada harga yang lebih rendah dari harga saat penjualan pendek dieksekusi.",
  "USPRIMERATE": "SUKU BUNGA AS",
  "USPRIMERATEText": "Tingkat suku bunga yang akan diberikan oleh bank-bank AS kepada nasabah korporat utama mereka.",
  "VALUEDATE": "TANGGAL NILAI",
  "VALUEDATEText": "Tanggal di mana pihak-pihak yang bertransaksi setuju untuk menyelesaikan kewajiban masing-masing. Untuk transaksi mata uang spot, tanggal nilai biasanya dua hari kerja ke depan. Juga dikenal sebagai tanggal jatuh tempo, ini adalah tanggal penyelesaian transaksi.",
  "VARIATIONMARGIN": "MARGIN VARIASI",
  "VARIATIONMARGINText": "Dana yang harus disimpan oleh trader di akun mereka untuk menjaga agar perdagangan dengan leverage tetap terbuka.  Istilah ini biasanya mengacu pada dana tambahan yang harus disetorkan sebagai akibat dari pergerakan harga yang tidak menguntungkan.",
  "VOLATILITYVOL": "VOLATILITAS (VOL)",
  "VOLATILITYVOLText": "Ditandai dengan pergerakan harga yang cepat dan acak, ini adalah istilah yang digunakan untuk merujuk pada pasar aktif yang sering kali menghadirkan peluang perdagangan.",
  "VOLUME_s": "VOLUME",
  "VOLUMEText": "Jumlah total kontrak yang diperdagangkan selama periode tertentu.",
  "WeakDollarStrongDollar": "Dolar Lemah/ Dolar Kuat",
  "WeakDollarStrongDollarText": "Istilah dolar lemah dan dolar kuat digunakan di pasar valuta asing untuk menggambarkan nilai relatif dan kekuatan dolar AS terhadap mata uang lainnya. Dolar dikatakan lemah ketika lebih banyak dolar diperlukan untuk membeli satu unit mata uang lain dan kuat ketika beberapa dolar diperlukan untuk membeli satu unit mata uang lain.",
  "Whipsaw": "Jungkir balik",
  "WhipsawText": "Kondisi volatilitas ekstrem ketika pertumbuhan harga yang cepat diikuti oleh penurunan drastis (atau sebaliknya).",
  "Yard": "Halaman",
  "YardText": "Istilah forex untuk satu miliar unit",
  "YIELD": "YIELD",
  "YIELDText": "Penghasilan yang diperoleh dari investasi.",
  "steps_heading1": "Informasi Pribadi",
  "steps_heading2": "Deklarasi",
  "steps_heading3": "Unggah Dokumen Pribadi",
  "step1_personalinfo": "Informasi Pribadi",
  "step1_fname": "Nama depan",
  "step1_age_error": "Maaf, kami hanya menerima klien berusia di atas 18 tahun",
  "step1_lname": "Nama belakang",
  "step1_dob": "DOB",
  "step1_dobrequired": "DOB diperlukan",
  "step1_below18": "Usia Anda di bawah 18 tahun",
  "step1_addinfo": "Informasi Alamat",
  "step1_city": "Kota",
  "step1_postalcode": "Kode Pos",
  "step1_countryRes": "Negara Tempat Tinggal",
  "step1_otherinfo": "Informasi Lain",
  "step1_addInfo": "Informasi Tambahan",
  "step1_phno": "Nomor Telepon",
  "step1_phnoRequired": "Nomor telepon diperlukan",
  "step1_correctno": "Masukkan nomor telepon yang benar",
  "step1_prefcurrency": "Pilih Mata Uang Dompet Pilihan",
  "step1_pep": "Apakah Anda Orang yang Terpapar Politik (Politically Exposed Person/PEP)?",
  "step1_usPerson": "Apakah Anda orang Amerika Serikat?",
  "step1_Next": "Berikutnya",
  "step1_firstmember": "Informasi Anggota Pertama",
  "step1_member1dob": "Anggota 1 Tanggal Lahir diperlukan",
  "step1_member1age": "Anggota 1 Usia di bawah 18 tahun",
  "step1_secondmember": "Informasi Anggota Kedua",
  "step1_menber2dobreq": "Anggota 2 Tanggal Lahir diperlukan",
  "step1_member2age": "Anggota 2 Usia di bawah 18 tahun",
  "step1_adressinfo": "Informasi Alamat",
  "step1_companyinfo": "Informasi Perusahaan",
  "step1_companyname": "Nama Perusahaan",
  "step1_incopDate": "Tanggal Pendirian",
  "step1_incodateReq": "Tanggal Pendirian diperlukan",
  "step1_futuredate": "Tanggal masa depan tidak memungkinkan",
  "step1_authorperson": "Informasi Orang yang Berwenang",
  "step1_companyAdrsinfo": "Informasi Alamat Perusahaan",
  "step1_regAddone": "Alamat Perusahaan Terdaftar Baris 1",
  "step1_regAddtwo": "Alamat Perusahaan Terdaftar Baris 2",
  "step1_country": "Negara",
  "step1_minimumph": "Nomor telepon minimal terdiri dari 8 karakter",
  "step1_maxphone": "Nomor telepon tidak boleh lebih dari 15 karakter",
  "step1_stepMsz2": "PEP adalah orang perorangan yang telah dipercaya untuk menjalankan fungsi publik yang menonjol di negara mana pun, serta anggota keluarga dekatnya dan orang-orang yang dikenal sebagai rekan dekat orang tersebut: <ul> <li>Kepala negara, kepala pemerintahan, menteri dan wakil atau asisten menteri,</li> <li>Anggota parlemen atau badan legislatif serupa,</li> <li>Anggota dewan pengurus partai politik,</li> <li>Anggota mahkamah agung, mahkamah konstitusi, atau lembaga yudisial tingkat tinggi lainnya yang keputusannya tidak bisa diajukan banding, kecuali dalam keadaan luar biasa,</li> <li>Anggota pengadilan auditor atau dewan bank sentral,</li> <li>Duta besar, kuasa usaha dan perwira tinggi dalam angkatan bersenjata,</li> <li>Anggota badan administratif, manajemen atau pengawas bisnis pemerintah atau badan usaha milik negara,</li> <li>Direktur, wakil direktur, dan anggota dewan direksi atau orang yang memegang posisi yang setara di organisasi internasional,</li> <li>Walikota </li> </ul> </li> </ul",
  "step1_stepMsz3": "Definisi orang AS (\"orang Amerika Serikat\") meliputi: <ul> <li> Warga negara atau penduduk AS (termasuk kewarganegaraan ganda),</li> <li> Orang asing AS (penduduk untuk tujuan perpajakan)</li> <li> Seseorang yang lahir di AS? </li> <li> Seseorang dengan alamat surat atau tempat tinggal di AS saat ini (termasuk kotak pos AS atau alamat yang diurus di AS) </li> <li> Seseorang dengan nomor telepon AS saat ini </li> <li> Seseorang dengan instruksi tetap untuk mentransfer dana ke rekening yang dikelola di Amerika Serikat?",
  "step2_financialDetails": "Rincian Keuangan",
  "step2_txt1": "Jika dipekerjakan, sebutkan",
  "step2_txt2": "Perkiraan Pendapatan Tahunan (USD)",
  "step2_txt3": "Perkiraan Kekayaan Bersih (USD)",
  "step2_txt4": "Sumber Dana",
  "step2_txt5": "Simpan & Lanjutkan",
  "step2_txt6": "Pekerjaan",
  "step2_txt7": "Warisan",
  "step2_txt8": "Investasi",
  "step2_txt9": "Real Estat",
  "step2_txt10": "Tabungan",
  "step2_txt11": "Lainnya",
  "step3_Questions": "Pertanyaan",
  "step3_txt1": "Mari uji pengalaman trading Anda",
  "step3_txt2": "Sebagai entitas teregulasi, kami diharuskan untuk menilai apakah Anda memiliki pemahaman yang tepat untuk memperdagangkan produk dengan leverage. Mohon lengkapi tes Kepatutan dengan hati-hati, karena jawaban Anda akan digunakan untuk menentukan apakah Anda dapat membuka akun trading Live bersama kami.",
  "step3_txt3": "Mulai Tes",
  "step4_readaccept": "Saya telah membaca, memahami, dan menerima",
  "step4_ClientAgreement": "Perjanjian Klien",
  "step4_privacyplicy": "Kebijakan Privasi",
  "step4_and": "dan",
  "step4_riskDisclosr": "Dokumen Pengungkapan Risiko",
  "step4_termsAgreeRqd": "Harap setujui persyaratan ini",
  "step4_policytwo": "Saya setuju untuk data pribadi saya diproses dan disimpan sesuai dengan Kebijakan Privasi, dan agar Fxview menghubungi saya mengenai informasi penting untuk akun saya",
  "step4_AfterCalling": "Catatan: Setelah mengklik",
  "step4_saveContinue": "Simpan & Lanjutkan",
  "step4_allInfoCorrect": "Anda tidak akan dapat mengubah informasi langkah sebelumnya. Pastikan semua informasi sudah benar!",
  "step5_browsersupport": "Mungkin browser menghadapi masalah teknis dengan webcam",
  "step5_cameradenied": "Izin kamera ditolak",
  "step5_scanqrcode": "Pindai kode QR sebagai gantinya",
  "step5_scanqrmobile": "Pindai kode QR ini menggunakan kamera ponsel Anda atau aplikasi kode QR",
  "step5_keepageopen": "Harap tetap buka halaman ini saat Anda menggunakan ponsel Anda",
  "step5_continueBrowser": "Lanjutkan dengan Browser",
  "step5_docSubsuccess": "Dokumen Anda telah berhasil dikirimkan. Mohon bersabar sementara kami meninjau dokumen Anda dan mungkin diperlukan waktu hingga 24 jam atau lebih selama waktu sibuk.",
  "step5_reviewstatus": "klik di sini untuk meninjau status tiket Anda",
  "step5_identifyDoc": "DOKUMEN IDENTITAS",
  "step5_proofresidence": "BUKTI DOKUMEN KEPENDUDUKAN",
  "step5_uploadphototext": "Unggah foto dokumen identitas Anda. Pastikan bahwa detail pada kartu identitas sesuai dengan informasi yang Anda masukkan dalam formulir informasi pribadi.",
  "step5_uploadproof": "Unggah bukti alamat tempat tinggal Anda (atas nama Anda & tidak lebih dari 6 bulan). Harap dicatat bahwa kami tidak menerima tangkapan layar.",
  "step5_takephoto": "Ambil foto Surat Izin Mengemudi Anda dan unggah di sini",
  "step5_takegovernid": "Ambil foto kartu identitas yang dikeluarkan oleh Pemerintah dan unggah di sini",
  "step5_goodQuality": "Kualitas yang baik:",
  "step5_brightclear": "Cerah dan jernih",
  "step5_note": "Catatan:",
  "step5_allcorner": "Semua sudut dokumen harus terlihat dan dokumen harus valid (tidak kedaluwarsa)",
  "step5_allcorner1": " Harus mencantumkan nama lengkap, alamat tempat tinggal, institusi penerbit, dan tanggal penerbitan. Semua sudut dokumen harus terlihat dengan jelas.",
  "step5_uploadfrontside": "Silakan unggah sisi depan dokumen Anda",
  "step5_maximumfilesize": "Ukuran file maksimum yang dapat diunggah hingga",
  "step5_maxfilesize": "Ukuran file maksimum yang diterima adalah hingga",
  "step5_uploadbackside": "Unggah bagian belakang dokumen Anda",
  "step5_upload": "Unggah",
  "step5_idenfNumber": "Mohon sebutkan nomor identitas Anda yang tertera pada dokumen identitas Anda.",
  "step5_uploadpassport": "Ambil foto Paspor Anda dan unggah di sini",
  "step5_photolicense": "Ambil foto Surat Izin Mengemudi Anda dan unggah di sini",
  "step5_photogovernmentID": "Ambil foto kartu identitas yang dikeluarkan oleh Pemerintah dan unggah di sini",
  "step5_proofsixold": "Ambil foto bukti atau tempat tinggal Anda (tidak lebih dari 6 bulan):",
  "step5_bankstatement": "Rekening Koran, Tagihan Utilitas (air, listrik, internet rumah atau telepon rumah), Dokumen Pajak, Perjanjian Sewa (jika diterbitkan dalam 6 bulan terakhir)",
  "step5_uploadyourDoc": "Unggah dokumen Anda",
  "step5_idnorequired": "Diperlukan Nomor ID.",
  "step5_filesizemax": "ukuran file bisa maksimal",
  "step5_filesallowed": "Hanya file jpg, jpeg, png, pdf yang diperbolehkan!",
  "step5_uploadbothside": "Silakan unggah kedua sisi dokumen Anda",
  "step5_verifydoc": "Silakan unggah dokumen Anda untuk memverifikasi informasi Anda",
  "step5_continuemobile": "Lanjutkan dengan ponsel",
  "step5_recentphoto": "Silakan unggah foto terbaru Anda",
  "step5_photoverif": "VERIFIKASI FOTO",
  "step5_legitimacy": "Semua pengguna diwajibkan untuk mengunggah foto Verifikasi. Ini hanyalah sebagian dari berbagai teknik dan sistem yang kami terapkan untuk memastikan keabsahan pengguna kami.",
  "step5_back": "kembali",
  "step5_start": "Gunakan Webcam",
  "step5_TakeSelfie": "Mengambil foto selfie",
  "step5_webcamdont": "Lanjutkan dengan Ponsel",
  "step5_captureimage": "Menangkap Gambar",
  "step5_cancel": "Batal",
  "step5_filemax": "Ukuran file dapat maksimal sebesar",
  "step5_choosefileupload": "Pilih File Untuk diunggah",
  "step5_allowmaxsize": "Ukuran file maksimum yang kami izinkan adalah sebesar",
  "step5_useWebcam": "Gunakan Kamera Web",
  "soclTrade_zullutrade": "Zulu Trade",
  "soclTrade_mql": "MQL5",
  "zulu_trade": "ZuluTrade",
  "zulu_zulitradeinfo": "Zulu trade adalah platform perdagangan sosial di mana Anda dapat mengikuti pedagang di seluruh dunia dan menyalin perdagangan sambil belajar dari strategi yang mereka gunakan. Berdasarkan informasi lengkap yang tersedia untuk gaya dan kinerja perdagangan mereka, Anda dapat dengan mudah membuat pedagang pilihan Anda dan setelah Anda mengikuti mereka, perdagangan mereka akan secara otomatis disalin di akun Anda.",
  "zulu_createAccount": "Buat Akun Zulu",
  "zulu_setupzulutrade": "Cara mengatur akun ZuluTrade",
  "zulu_registeropen": "Daftar dan buka akun Fxview ZuluTrade.",
  "zulu_findaccount": "Danai akun dengan minimal $100 untuk menerima kredensial login dari ZuluTrade.",
  "zulu_logintozulu": "Masuk ke situs web zulu trade dan mulai mengikuti trader pilihan Anda.",
  "mampam_heading": "MAM/PAMM",
  "mampam_programenable": "Program MAM/PAMM fxview memungkinkan trader berpengalaman untuk mengelola beberapa sub akun di bawah satu akun master, secara profesional.",
  "mampam_knowmore": "Ketahui Lebih Lanjut",
  "mampam_becameinvestor": "Bagaimana cara menjadi investor:",
  "mampam_clicktobecame": "Klik \"Menjadi Investor\"",
  "mampam_uniquepamid": "Masukkan ID PAMM unik manajer Anda untuk melihat profilnya.",
  "mampam_createinverstor": "Buat akun investor Anda dan hubungkan dengan akun PAMM",
  "mampam_monitoracc": "Pantau akun Anda melalui dasbor investor PAMM",
  "mampam_connectmanager": "Terhubung ke Manajer",
  "mampam_becomemanager": "Bagaimana menjadi seorang Manajer:",
  "mampam_clickbecomemanager": "Klik \"menjadi manajer\"",
  "mampam_meetconditions": "Penuhi persyaratan yang diperlukan untuk menerima Id PAMM unik Anda",
  "mampam_manageaccount": "Kelola akun Anda melalui portal PAMM eksklusif",
  "mampam_becomeManager": "Menjadi Manajer",
  "mampamm_account_tab": "Sub Rekening",
  "mampamm_account_account_type": "Sub Rekening",
  "mampamm_account_heading": "Akun IB MAMM",
  "mampamm_account_description": "Program MAM/PAMM fxview memungkinkan trader berpengalaman untuk mengelola beberapa sub akun di bawah satu akun master, secara profesional.",
  "mampamm_account_regsiter_heading": "Langkah-langkah untuk mendaftarkan Akun IB MAMM",
  "mampamm_account_clicktobecame": "Klik \"Menjadi Investor\"",
  "mampamm_account_uniquepamid": "Masukkan ID PAMM unik manajer Anda untuk melihat profilnya.",
  "mampamm_account_createinverstor": "Buat akun investor Anda dan hubungkan dengan akun PAMM",
  "mampamm_account_monitoracc": "Pantau akun Anda melalui dasbor investor PAMM",
  "mampamm_account_disclaimer": "Penafian",
  "mampamm_account_username": "Nama",
  "mampamm_account_usernameRequired": "Nama harus diisi",
  "mampamm_account_signature": "Tanda tangan",
  "mampamm_account_signatureRequired": "Tanda tangan diperlukan",
  "mampamm_account_signatureMatchError": "Tanda tangan tidak cocok dengan nama pengguna",
  "mampamm_account_termscondition": "Saya menerima semua Syarat dan Ketentuan.",
  "mampamm_account_termsconditionRequired": "Harap setujui syarat dan ketentuan untuk melanjutkan",
  "mampamm_account_Proceed": "Lanjutkan untuk Membuat Akun IB MAMM",
  "mampamm_account_Cancel": "Batal",
  "mampamm_account_Create": "Buat Akun IB MAMM",
  "mampamm_account_List_Header": "Akun MAMM IB SAYA",
  "mampamm_account_Open_Ib_Mam_Pamm": "Buka Akun Perdagangan IB MAMM",
  "mampamm_account_Created_Successfully": "Akun IB MAMM Anda telah berhasil dibuat. Kredensial Anda adalah:",
  "mampamm_account_Disclaimer_Approved_Successfully": "Penafian berhasil disetujui",
  "mampamm_account_No_Pdf_Found": "Tidak ada pdf yang ditemukan",
  "mql_heading": "MQL5",
  "mql_text": "MQL5 adalah salah satu komunitas copy-trading terbesar di dunia, yang menghubungkan trader pemula dengan trader berpengalaman. Pengguna dapat memilih dari ribuan sinyal terverifikasi gratis dan bebas biaya untuk meningkatkan kinerja trading mereka",
  "mql_createliveAcc": "Buat Akun Live",
  "mql_stepsRegister": "Langkah-langkah untuk mendaftarkan MQL5",
  "mql_stepone": "Daftarkan akun MQL5 di situs webnya",
  "mql_stepTwo": "Buka platform Metatrader dan masuk ke Tools >> Options dan klik pada tab Community. Login ke akun MQL5 dan klik OK.",
  "mql_stepThree": "Buka tab sinyal pada jendela terminal dan pilih sinyal yang ingin Anda ikuti.",
  "unaut_under": "Di bawah",
  "unaut_Verification": "Verifikasi",
  "unaut_pendingVerificationMsz1": "Permohonan Anda sedang ditinjau oleh departemen kepatuhan kami. Diperlukan waktu 3-4 hari kerja untuk memverifikasi dokumen Anda. Anda akan menerima email setelah dokumen Anda diverifikasi",
  "createzullu_Your": "Anda",
  "createzullu_successcreate": "Akun zulu telah berhasil dibuat. Kredensial Anda adalah:",
  "createzullu_accountBaseCurrency": "Mata Uang Dasar Akun",
  "createzullu_tradenow": "Berdagang Sekarang",
  "fund_now": "Danai Sekarang",
  "createzullu_forWeb": "Untuk Web",
  "createzullu_open": "Buka",
  "createzullu_tradingAcc": "Akun Perdagangan",
  "createzullu_classic": "Klasik",
  "createzullu_profitsharing": "Bagi Hasil",
  "createzullu_USD": "USD",
  "createzullu_EUR": "EUR",
  "createzullu_GBP": "GBP",
  "createzullu_AUD": "AUD",
  "createzullu_ZAR": "ZAR",
  "createzullu_leverageField": "Leverage adalah bidang yang wajib diisi",
  "createzullu_accountPassword": "Kata Sandi Akun Perdagangan",
  "createzullu_passwordcontain": "Kata sandi Anda harus terdiri dari minimal 6 karakter dan maksimal 15 karakter, serta menyertakan setidaknya 1 karakter khusus (!@#$%^*/)",
  "createzullu_createAccount": "Buat Akun",
  "demoacc_demomsg": "akun demo telah berhasil dibuat. Kredensial Anda adalah:",
  "demoacc_MT4": "MetaTrader 4",
  "demoacc_MT5": "MetaTrader 5",
  "demoacc_passwordMust": "Kata sandi Anda harus terdiri dari minimal 6 karakter dan maksimal 24 karakter, serta menyertakan setidaknya 1 karakter khusus (!@#$%^*/)",
  "liveacc_accounthas": "akun live telah",
  "demoacc_accounthas": "akun demo telah",
  "liveacc_successfully": "berhasil",
  "liveacc_credentialsare": "dibuat. Kredensial Anda:",
  "wit_Wallet_from_wallet": "dari dompet",
  "depMsz11": "Bukan akun Skrill yang tepat? Silakan",
  "wit_Wallet_Back": "Kembali ke dompet",
  "wit_Wallet_No": "Tidak ada dompet",
  "wit_withdrawal": "Penarikan",
  "wit_freeMargin": "Margin Bebas",
  "wit_withdrawalMsz1": "Maaf, Anda belum memenuhi syarat untuk melakukan penarikan dana. Menyetor dan berdagang dapat membantu Anda memenuhi syarat!",
  "wit_PrincipalWithAmount": "Jumlah Penarikan Dana Pokok",
  "wit_AccNumber": "Nomor Rekening:",
  "wit_skrillId": "ID Skrill:",
  "wit_netId": "ID Neteller:",
  "wit_creditCardNumber": "nomor kartu kredit",
  "wit_expiryDate": "tanggal kedaluwarsa",
  "wit_allowOption": "Silakan pilih dari opsi yang diizinkan di atas",
  "wit_WithdrawalMethodReq": "Diperlukan Metode Penarikan Dana",
  "wit_EnterWithdrawal": "Masukkan penarikan",
  "wit_requestWithdrawal": "Anda dapat meminta penarikan dari opsi pembayaran yang baru disetujui setelah 24 jam persetujuan",
  "wit_withdrawalMsz2": "Kami telah menerima permintaan penarikan dana Anda, dan akan memberi tahu Anda",
  "wit_withCont1": "Fxview tidak membebankan biaya penarikan. Namun, harap diperhatikan bahwa pemroses pembayaran/perantara keuangan mungkin membebankan biaya transaksi.",
  "wit_withCont2": "Karena pembatasan transaksi pihak ketiga, dana hanya dapat dikembalikan ke rekening bank dengan nama yang sama dengan akun trading Fxview Anda. Selain itu, dana hanya akan dikembalikan ke rekening bank yang sama dengan tempat dana tersebut diterima.",
  "wit_withCont3": "Jumlah total yang dapat Anda tarik ke dalam kartu Anda tidak dapat melebihi jumlah total yang didepositkan ke dalam kartu. Jumlah yang melebihi level ini dapat ditarik ke rekening bank, Neteller, atau Skrill Anda",
  "withdraw_backWithdraw": "Kembali ke Penarikan Dana",
  "withdrawList": "Daftar Penarikan Dana",
  "withdrawList_all": "Semua",
  "withdrawList_pending": "Tertunda",
  "withdrawList_processed": "Diproses",
  "withdrawList_rejected": "Ditolak",
  "withdrawList_created": "Tanggal",
  "withdrawList_accountId": "ID Rekening/Nomor Dompet",
  "withdrawList_amount": "Jumlah",
  "withdrawList_currency": "Mata uang",
  "withdrawList_withdrawalType": "Jenis Penarikan",
  "withdrawList_method": "Metode",
  "withdrawList_withdrawalStatus": "Status",
  "withdrawList_detail": "Detail",
  "withdrawList_viewTicket": "Lihat Tiket",
  "Wallet_Wallet": "Dompet",
  "Wallet_Loyalty_Points": "Poin Loyalitas",
  "Wal_detail_Add_New": "Tambahkan Mata Uang Dompet Baru",
  "Wal_detail_Wallet_ID": "ID Dompet",
  "Wal_detail_Deposit": "Deposit",
  "Wal_detail_Withdraw": "Menarik diri",
  "Wal_detail_Transfer": "Transfer",
  "Wal_detail_curr_required": "Kolom mata uang wajib diisi",
  "Wal_detail_Submit": "Kirim",
  "Wal_detail_Trans_History": "Riwayat Transaksi",
  "Wal_detail_Date": "Tanggal",
  "Wal_detail_Time": "Waktu",
  "Wal_detail_Type": "Jenis",
  "Wal_detail_From": "Dari",
  "Wal_detail_To": "Untuk",
  "Wal_detail_Amount": "Jumlah",
  "Wal_detail_Status": "Status",
  "Wal_detail_availAmount": "Jumlah yang tersedia:",
  "acc_fund_Deposit": "Deposit",
  "acc_fund_Withdrawal": "Penarikan",
  "chang_wal_curr_Internal_Transf": "Transfer Internal Dompet",
  "chang_wal_curr_Transf_Wall_amount": "Jumlah Transfer Dompet",
  "chang_wal_curr_Back": "Kembali ke Dompet",
  "loyalP_Reward_Points": "Poin Penghargaan Loyalitas",
  "loyalP_Know_More": "Ketahui Lebih Lanjut",
  "loyalP_Trans_Wallet": "Transfer ke Dompet",
  "loyalP_Transfer": "Transfer",
  "loyalP_transf_TotalP": "Total poin loyalitas",
  "loyalP_transf_Amou_Avail": "Jumlah yang tersedia",
  "loyalP_transf_Enter_p_transfe": "Masukkan titik yang akan ditransfer",
  "loyalP_transf_Cancel": "Batal",
  "loyalP_transf_Transfer": "Transfer",
  "loyalP_transf_Back": "Kembali ke Dompet",
  "loyalP_transToAcc": "Transfer ke ID Dompet",
  "loyalP_fieldReq": "Bidang harus diisi",
  "loyalP_fieldReq_min": "Poin loyalitas minimum yang dapat ditukarkan = 100 poin loyalitas",
  "loyalP_intTransMsz2": "Silakan klik tautan untuk mengonfirmasi transfer internal Anda",
  "loyalP_intTransMsz3": "Transfer telah berhasil diselesaikan",
  "loyalP_fromTradId": "Dari ID Perdagangan",
  "loyalP_toTradId": "Ke ID Perdagangan",
  "loyalP_transferAmount": "Jumlah yang ditransfer",
  "loyal_card_det_You_are_a": "Anda adalah",
  "loyal_card_det_member": "anggota",
  "loyal_card_det_Points": "Poin",
  "loyal_card_det_Last_Credit_On": "Kredit Terakhir Aktif",
  "loyal_card_det_Earn": "Hasilkan",
  "loyal_card_det_more_points_to_jump_to": "lebih banyak poin untuk melompat ke",
  "loyal_card_det_gain_add_benefi": "untuk mendapatkan manfaat tambahan",
  "loyal_List_Trans_History": "Riwayat Transaksi",
  "loyal_List_Date": "Tanggal",
  "loyal_List_Activity": "Aktivitas",
  "loyal_List_Volume": "Volume",
  "loyal_List_Points": "Poin",
  "loyal_List_Cr_Db": "Cr / Db",
  "loyal_ver_back": "Kembali ke Dompet",
  "redeamP_your_points": "Tukarkan poin loyalitas Anda",
  "redeamP_Points": "Poin",
  "redeamP_Redeem": "Tebus",
  "redeamP_Red_Points": "Tukarkan Poin",
  "redeamP_Now": "Tebus Sekarang",
  "redeamP_walletpoints": "Silakan Tukarkan Poin Dompet sesuai dengan rincian berikut ini:",
  "redeamP_pointdesc": "<br> point_desc :",
  "tool_overview": "Ikhtisar",
  "tool_autochartistScan": "Pemindai AutoChartist",
  "tool_autochartistWeb": "Web AutoChartist",
  "tool_Vpsheading": "VPS",
  "tool_ecoCalendar": "Kalender Ekonomi",
  "tool_tradingToolbox": "Kotak Peralatan Pedagang",
  "tool_Calculator": "Kalkulator",
  "tool_tradingHOur": "Jam Perdagangan",
  "tool_Signal": "Sinyal",
  "autoScan_knoMore": "Ketahui lebih lanjut",
  "autoScan_DownLive": "Unduh untuk Akun Live",
  "autoScan_HowInstall": "Cara memasang AutoChartist",
  "autoScan_usrGuide": "panduan pengguna",
  "autoScan_goTool": "Di platform, buka alat > opsi > penasihat ahli untuk mengizinkan impor DLL dan klik OK.",
  "toolVps_sureImp": "Apakah Anda yakin untuk menerapkan operasi ini?",
  "toolVps_confirm": "konfirmasi",
  "toolVps_cancel": "membatalkan",
  "toolVps_Shut_Down": "Shut-Down",
  "toolVps_Restart": "Mulai ulang",
  "toolVps_Reboot": "Reboot",
  "toolVps_Change_Pass": "Ubah Kata Sandi",
  "toolVps_VieDet": "Lihat Detail",
  "toolVps_UpdAcc": "Perbarui Akun",
  "toolVps_Unsubscribe": "Berhenti berlangganan",
  "toolVps_vpsList": "Daftar <span>Server</span> Virtual Private</span> (VPS)",
  "toolVps_createVps": "Buat VPS",
  "toolVps_SubList": "Daftar Langganan",
  "toolVps_accWalt": "Rekening/Dompet",
  "toolVps_Priodicity": "Priodisitas",
  "toolVps_Price": "Harga",
  "toolVps_strtDate": "Tanggal Mulai",
  "toolVps_endDate": "Tanggal Akhir",
  "toolVps_Action": "Tindakan",
  "toolVps_vps": "Virtual Private <span>Server</span>(VPS)",
  "toolVps_vpsTilte": "Nikmati pengalaman trading yang tak tertandingi bersama kami, di mana stabilitas trading Anda terjamin. Tidak perlu khawatir tentang latensi atau berurusan dengan banyak perangkat lunak pada sistem Anda lagi. Gunakan VPS GRATIS kami untuk mendapatkan respons secepat kilat untuk perdagangan Anda dan nikmati kecepatan yang mengesankan di platform kami.",
  "toolVps_redLate": "Mengurangi Latensi",
  "toolVps_freeOn5000": "Gratis dengan deposit $5.000 atau lebih",
  "toolVps_remoteAccess": "Akses Jarak Jauh",
  "toolVpsstab_Env": "Lingkungan yang Stabil",
  "toolVps_back_vpsList": "Kembali ke Daftar VPS",
  "toolVps_tc": "Syarat dan Ketentuan Berlaku",
  "toolVps_Plan": "Rencana",
  "toolVps_Status": "Status",
  "toolVps_type": "Jenis",
  "toolVps_nextpayment": "Pembayaran Berikutnya",
  "toolVps_passWordMustContain12": "Kata sandi Anda harus terdiri dari setidaknya 12 karakter, dan mencakup setidaknya 1 angka, 1 karakter huruf besar, dan 1 karakter khusus (!@#$%^&*/)",
  "toolVps_verifySubscribe": "Permintaan pembaruan akun trading Anda telah berhasil diproses",
  "toolVps_back_subList": "Kembali ke Daftar Langganan",
  "toolVps_reqProcessing": "pemrosesan permintaan...",
  "toolVps_reqVerify": "Minta Verifikasi",
  "toolVps_reqFailed": "Permintaan Gagal",
  "VpsSub_1_Record": "Anda hanya memiliki satu catatan. Harap buat setidaknya satu akun trading atau wallet sebelum mencoba mengubah akun berlangganan.",
  "VpsSub_liveAcc": "Akun Live",
  "VpsSub_Wallet": "Dompet",
  "VpsSub_ChangeTradAcc": "Ubah Akun Perdagangan Berlangganan",
  "VpsSub_back_subLis": "Kembali ke Daftar Langganan",
  "VpsSub_Submit": "Kirim",
  "VpsSub_received_request": "Kami telah menerima permintaan akun trading chnage Anda, dan akan memberi tahu Anda sesuai dengan permintaan Anda",
  "VpsSub_withdrawalAuthMessage": "Mohon verifikasi permintaan penarikan dana dengan mengklik tautan yang kami kirimkan ke email Anda yang terdaftar",
  "VpsSub_noTradingAccFound": "Tidak Ditemukan Akun Trading Live!",
  "VpsUnSub_1_record": "Anda hanya memiliki satu catatan. Harap buat setidaknya satu akun trading atau wallet sebelum mencoba mengubah akun berlangganan.",
  "VpsUnSub_liveAcc": "Akun Live",
  "VpsUnSub_Wallet": "Dompet",
  "VpsUnSub_sureUnsub": "Apakah Anda yakin untuk berhenti berlangganan",
  "VpsUnSub_plan_": "rencana?",
  "VpsUnSub_confirm": "konfirmasi",
  "VpsUnSub_Cancel": "Batal",
  "VpsUnSub_received_request": "Kami telah menerima permintaan akun trading chnage Anda, dan akan memberi tahu Anda sesuai dengan permintaan Anda",
  "VpsUnSub_back_subList": "Kembali ke Daftar Langganan",
  "VpsUnSubVer_successfully": "Permintaan berhenti berlangganan paket Anda telah berhasil diproses",
  "VpsUnSubVer_back_subList": "Kembali ke Daftar Langganan",
  "marktTrdHour_title": "Jam Perdagangan Pasar",
  "marktTrdHour_txt": "Waktu server kami adalah GMT+3 selama Waktu Musim Panas Amerika Serikat (DST) dan GMT+2 selama Waktu Musim Dingin Amerika Serikat (Non-DST).",
  "marktTrdHour_table_below": "Tabel di bawah ini mencantumkan jam buka dan tutup berbagai instrumen dan kelas aset sesuai waktu server kami.",
  "marktTrdHour_Forex": "Forex",
  "marktTrdHour_Indices": "Indeks",
  "marktTrdHour_Commodities": "Komoditas",
  "marktTrdHour_Open": "Buka",
  "marktTrdHour_Close": "Tutup",
  "marktTrdHour_Break": "Istirahat",
  "trdMarktPlac_title": "<span>Pasar <span>Pedagang</span>",
  "trdMarktPlac_txt": "Jelajahi marketplace kami untuk mengakses strategi yang dibuat oleh beberapa trader terbaik dunia, atau rancang strategi Anda sendiri dan kami akan membantu Anda membuatnya.  Marketplace kami adalah toko serba ada untuk membawa trading Anda ke level berikutnya.",
  "trdMarktPlac_Automate": "Otomatiskan <span>trading</span> Anda untuk mendapatkan hasil maksimal dari pasar",
  "trdMarktPlac_Customise": "Sesuaikan perdagangan Anda",
  "trdMarktPlac_Customise_Txt": "Tentukan kebutuhan Anda dan wujudkan sistem Anda dengan terhubung dengan pengembang yang akan membangunnya untuk Anda",
  "trdMarktPlac_Risk_manag": "Manajemen risiko",
  "trdMarktPlac_Risk_manag_txt": "Tinjau kinerja penyedia sinyal berdasarkan pengalaman mereka, perdagangan terbaik & terburuk, profil risiko, dan lainnya",
  "trdMarktPlac_Browse_library": "Jelajahi perpustakaan kami",
  "trdMarktPlac_Browse_libraryTxt": "Jelajahi perpustakaan EA dan indikator kami yang luas untuk MT4, MT5, dan ActTrader, dan temukan yang paling sesuai dengan kebutuhan Anda",
  "trdMarktPlac_Categories": "Kategori",
  "trdMarktPlac_All": "Semua",
  "trdMarktPlac_Expert": "Ahli",
  "trdMarktPlac_Advisors": "Penasihat",
  "trdMarktPlac_Indicators": "Indikator",
  "trdMarktPlac_ActTrader": "ActTrader",
  "trdMarktPlac_Popular": "Populer",
  "trdMarktPlac_New": "Baru",
  "trdMarktPlac_Free": "Gratis",
  "trdMarktPlac_Paid": "Dibayar",
  "trdMarktPlac_Long_Str": "Strategi Jangka Panjang",
  "trdMarktPlac_2frame": "Dua Frame",
  "trdMarktPlac_StratCon2": "Strategi terdiri dari dua riwayat grafik yang berbeda:",
  "trdMarktPlac_Details": "Detail",
  "trdMarktPlac_Add_List": "Tambahkan ke Daftar",
  "trdMarktPlac_Hammer_Ass": "Asisten Palu",
  "trdMarktPlac_Strat_trad_assis": "Strategi ini (asisten perdagangan) akan memperingatkan Anda ketika palu terbentuk dan",
  "trdMarktPlac_Pos_Mgmt": "Manajemen Posisi",
  "trdMarktPlac_Lot_Cal": "Kalkulator Lot",
  "trdMarktPlac_Lot_Cal_txt": "Kalkulator Lot - adalah alat Forex yang memungkinkan Anda menghitung ukuran ...",
  "trdMarktPlac_Short_Strat": "Strategi Jangka Pendek",
  "trdMarktPlac_Reg_Stra": "Strategi Regresi",
  "trdMarktPlac_Reg_StraTxt": "Strategi membuka posisi beli ketika nilai rendah lilin saat ini adalah = sabuk atas ..",
  "trdMarktPlac_NoData": "Tidak ada data",
  "ecoCalendar": "Kalender Ekonomi",
  "ecoCal_Title_Txt": "Melacak peristiwa dan rilis ekonomi penting yang berdampak pada Forex, Komoditas, dan Indeks.",
  "ecoCal_Up_next": "Berikutnya",
  "ecoCal_Country": "Negara",
  "ecoCal_Select_All": "Pilih Semua",
  "ecoCal_Clear": "Jelas",
  "ecoCal_My_Filter": "Filter Saya",
  "ecoCal_Default": "Default",
  "ecoCal_Impact": "Dampak",
  "ecoCal_All": "Semua",
  "ecoCal_Medium": "Sedang",
  "ecoCal_High": "Tinggi",
  "ecoCal_Save_filter": "Menyimpan pengaturan di filter saya",
  "ecoCal_Apply_Filter": "Terapkan Filter",
  "ecoCal_Time": "Waktu",
  "ecoCal_TimeZ_Settings": "Pengaturan Zona Waktu",
  "ecoCal_TimeZ": "Zona Waktu",
  "ecoCal_Select_TimeZ": "Pilih Zona Waktu",
  "ecoCal_TimeF": "Format Waktu",
  "ecoCal_Set_timeZ_Auto": "Mengatur zona waktu saya secara otomatis",
  "ecoCal_Save_Sett": "Simpan Pengaturan",
  "ecoCal_Cancel": "Batal",
  "ecoCal_noRecord": "Tidak ada catatan",
  "ecoCal_Event": "Acara",
  "ecoCal_Actual": "Sebenarnya",
  "ecoCal_Forecast": "Perkiraan",
  "ecoCal_Previous": "Sebelumnya",
  "tools_Trad_Tools": "Alat Perdagangan",
  "tools_Trad_Tools_Txt": "Buat keputusan investasi yang tepat dan tepat waktu dengan menggunakan perangkat trading kami yang membantu Anda mengidentifikasi peluang potensial dan membangun strategi trading yang lebih kuat",
  "tools_Auto_Scanner": "Pemindai AutoChartist",
  "tools_Auto_Scanner_txt": "Jangan pernah melewatkan peluang trading lagi..",
  "tools_VPS": "VPS",
  "tools_VPS_txt": "Nikmati VPS dasar gratis atau pilih berlangganan ...",
  "tools_Eco_Calendar": "Kalender Ekonomi",
  "tools_Eco_Calendar_txt": "Ikuti perkembangan peristiwa ekonomi penting...",
  "tools_Trad_Toolbox": "Kotak Peralatan Trader",
  "tools_Trad_Toolbox_txt": "Rangkaian alat bantu trading dan analisis premium...",
  "tools_Calculators": "Kalkulator",
  "tools_Calculators_txt": "Hitung nilai pip, margin, swap, dan lainnya...",
  "tools_TradeMarket": "Pasar Pedagang",
  "tools_TradeMarket_txt": "Temukan EA atau indikator ideal Anda, atau miliki...",
  "tools_Trad_Hours": "Jam Perdagangan",
  "tools_Trad_Hours_txt": "Lihat dengan cepat kapan pasar dibuka ...",
  "tools_Auto_Idea": "Ide AutoChartist",
  "tools_Auto_Idea_txt": "Jangan pernah melewatkan peluang trading lagi..",
  "tools_readmore": "Baca Lebih Lanjut",
  "tools_downloa": "unduh untuk",
  "MT4Demo": "Demo MT4",
  "MT5Demo": "Demo MT5",
  "toolor": "atau",
  "toolknowMore": "tahu lebih banyak",
  "chEn_entity": "Entitas",
  "chEn_global": "Fxview Global",
  "chEn_europe": "Fxview Eropa",
  "chEn_redirectmsg1": "Berdasarkan pilihan negara tempat tinggal Anda, Anda akan diarahkan ke situs web Charlgate Ltd. yang terdaftar di Siprus. Charlgate Ltd. berada di bawah kerangka kerja peraturan Eropa, dan termasuk dalam cakupan Markets in Financial Instrument Directive II (MiFID II). Selain itu, ada ketentuan untuk skema kompensasi investor.",
  "chEn_redirectmsg2": "",
  "chEn_continue": "Lanjutkan",
  "chEn_takeback": "Bawa aku kembali",
  "adchart_create": "Membuat",
  "adchart_save": "Simpan",
  "adchart_chart": "Bagan",
  "adchart_Studies": "Studi",
  "adchart_failedchart": "Gagal memuat grafik",
  "adchart_kindlyrefresh": "Mohon segarkan kembali",
  "chart_loadchartfail": "Gagal memuat grafik Mohon refresh!",
  "filter_Selecttimezone": "Pilih Zona Waktu",
  "filter_Low": "Rendah",
  "filter_medium": "Sedang",
  "filter_high": "Tinggi",
  "filter_submit": "Kirim",
  "head_Wallet": "Dompet",
  "head_loyality": "Poin Loyalitas",
  "head_createLiveAcc": "Buat Akun Live",
  "head_createDemoAcc": "Buat Akun Demo",
  "head_Notification": "Pemberitahuan",
  "head_seeAll": "Lihat Semua",
  "head_noNewNotification": "Tidak Ada Pemberitahuan Baru",
  "head_verified": "Terverifikasi",
  "head_deposit_enabled": "Setoran Diaktifkan",
  "head_notVerified": "Tidak Terverifikasi",
  "head_profile": "Profil",
  "head_changePassword": "Ubah Kata Sandi",
  "successMsz4": "Kata Sandi Berhasil Diubah",
  "head_security": "Keamanan",
  "head_referFriend": "Referensikan teman",
  "head_logout": "Keluar",
  "leftnav_dashboard": "Dasbor",
  "leftnav_wallet": "Dompet",
  "leftnav_accfunding": "Pendanaan Akun",
  "leftnav_manageAcc": "Kelola Akun",
  "leftnav_Depositbonus": "Bonus Deposit",
  "leftnav_socialTrade": "Perdagangan Sosial",
  "leftnav_tools": "Peralatan",
  "leftnav_education": "Pendidikan &",
  "leftnav_resources": "Sumber daya",
  "leftnav_downloadplatform": "Unduh Platform",
  "leftnav_support": "Dukungan",
  "load_norecordfound": "Tidak ada catatan yang ditemukan",
  "tradAcc_application": "Silakan lengkapi aplikasi akun Anda dan buat akun",
  "tradAcc_application1": "Lengkapi aplikasi akun Anda untuk mengakses fungsi ini",
  "tradAcc_trading": "perdagangan",
  "tradAcc_live": "hidup",
  "tradAcc_accountAccess": "untuk mengakses fungsi ini.",
  "tradAcc_resumeApplication": "Lanjutkan Aplikasi",
  "tradAcc_checkappStatus": "Permohonan Anda sedang ditinjau, Silakan periksa status permohonan Anda.",
  "tradAcc_ticket": "Tiket",
  "tradAcc_createliveAcc": "Silakan buat akun live untuk mengakses fungsi ini",
  "tradAcc_liveDemoAcc": "Silakan buat akun live atau demo untuk mengakses fungsi ini",
  "tradAcc_demoAcc": "Akun Demo",
  "tradAcc_createWallet": "Silakan buat dompet untuk mengakses fungsi ini",
  "tradAcc_wallet": "Dompet",
  "pagin_totalRecords": "Total Catatan",
  "acclist_fund": "Dana",
  "acclist_addFund": "Tambah Dana",
  "acclist_addFundTo": "Menambahkan Dana ke",
  "acclist_tradingId": "ID Perdagangan",
  "acclist_addingFundTo": "Menambahkan Dana ke",
  "acclist_fund_msz": "setoran berhasil",
  "acclist_fund_mszErr": "setoran tidak berhasil",
  "acclist_changeLeverage": "Ubah Leverage",
  "acclist_changePassword": "Ubah Kata Sandi",
  "acclist_internalTransfer": "Transfer Internal",
  "acclist_tradeNow": "Berdagang Sekarang",
  "acclist_detachAcc": "Lepaskan akun",
  "accId_TransFromAccId": "Transfer dari id rekening",
  "accId_selectAccountId": "pilih id akun",
  "accId_fieldReq": "Bidang harus diisi",
  "closetrad_login": "Masuk",
  "closetrad_order": "Pesan",
  "closetrad_symbol": "Simbol",
  "closetrad_volume": "Volume",
  "closetrad_openPrice": "Harga Terbuka",
  "closetrad_openTime": "Waktu Buka",
  "closetrad_commision": "Komisi",
  "closetrad_type": "Jenis",
  "closetrad_SL": "SL",
  "closetrad_TP": "TP",
  "closetrad_closePrice": "Harga Penutupan",
  "closetrad_closeTime": "Waktu Tutup",
  "closetrad_Swap": "Tukar",
  "closetrad_PNL": "PNL",
  "closetrad_comment": "Komentar",
  "closetrad_price": "Harga",
  "OCtradelist_balance": "Keseimbangan",
  "OCtradelist_margin": "Margin",
  "OCtradelist_equity": "Ekuitas",
  "OCtradelist_pnl": "PNL",
  "OCtradelist_tradeNow": "Berdagang Sekarang",
  "OCtradelist_opentrade": "Perdagangan Terbuka",
  "OCtradelist_closetrade": "Tutup Perdagangan",
  "openOrder_orderId": "ID Pesanan",
  "openOrder_accountId": "ID Akun",
  "openOrder_quantity": "Kuantitas",
  "openOrder_triggered": "Dipicu",
  "openOrder_side": "Samping",
  "openOrder_tradeId": "ID Perdagangan",
  "openOrder_profit": "Keuntungan",
  "openOrder_agentComm": "Komisi Agen",
  "openOrder_cmd": "Cmd",
  "openOrder_sl": "SL",
  "openOrder_tp": "TP",
  "openOrder_swaps": "Tukar guling",
  "trade_cal_title": "Kalkulator Perdagangan",
  "trade_cal_title_Txt": "Kalkulator online kami memberi Anda cara mudah untuk menganalisis trade yang Anda rencanakan. Kami membantu Anda menghitung nilai berdasarkan kondisi pasar dan memberi Anda hasil instan.",
  "trade_cal_Commission": "Komisi",
  "trade_cal_Multi_Target": "Multi-Target",
  "trade_cal_Pivot_Points": "Poin Pivot",
  "trade_cal_Profit_Loss": "Laba & Rugi",
  "trade_cal_Fibonacci": "Fibonacci",
  "trade_cal_Pip_Value": "Nilai Pip",
  "trade_cal_Swap": "Tukar",
  "trade_cal_Position_Size": "Ukuran Posisi",
  "trade_cal_Currency_Convertor": "Konverter Mata Uang",
  "cal_comm_title": "Komisi",
  "cal_comm_title_txt": "Hitung komisi yang akan Anda bayarkan untuk sebuah trade dengan kalkulator komisi kami. Fxview mengenakan komisi $1/100.000 sekali jalan (atau $2/100.000 pulang-pergi). Kalkulator komisi kami akan membantu Anda menghitung berapa besar komisi yang harus Anda bayarkan, untuk setiap perdagangan. Cukup masukkan kelas aset, simbol, mata uang dasar akun, dan besar trade, lalu tekan 'Hitung Sekarang'.",
  "cal_comm_forex": "forex",
  "cal_comm_commodities": "komoditas",
  "cal_comm_indices": "indeks",
  "cal_comm_Asset_Class": "Kelas Aset",
  "cal_comm_Field_req": "bidang harus diisi",
  "cal_comm_USD": "USD",
  "cal_comm_GBP": "GBP",
  "cal_comm_AUD": "AUD",
  "cal_comm_EUR": "EUR",
  "cal_comm_accBaseCurr": "Mata Uang Dasar Akun",
  "cal_comm_Symbol": "Simbol",
  "cal_comm_trade_size_lot": "Ukuran Perdagangan (dalam lot)",
  "cal_comm_now": "Hitung Sekarang",
  "cal_comm_Comm_roundT": "Komisi (pulang pergi)",
  "cal_marg_title": "Margin",
  "cal_marg_title_txt": "Kalkulator Margin membantu Anda menentukan margin yang diperlukan untuk membuka posisi. Cukup pilih kelas aset, simbol, mata uang akun, dan besar trade untuk mengetahui margin yang diperlukan berdasarkan leverage maksimum yang ditawarkan untuk berbagai jenis instrumen.",
  "cal_marg_Field_req": "bidang harus diisi",
  "cal_marg_accBaseCurr": "Mata Uang Dasar Akun",
  "cal_marg_Symbol": "Simbol",
  "cal_marg_trade_size_lot": "Ukuran Perdagangan (dalam lot)",
  "cal_marg_now": "Hitung Sekarang",
  "cal_marg_req": "Persyaratan Margin",
  "cal_marg_max_lev": "Max. Leverage",
  "cal_marg_forex": "forex",
  "cal_marg_commodities": "Komoditas",
  "cal_marg_indices": "Indeks",
  "cal_milti_Target": "Multi Target",
  "cal_milti_Target_txt": "Kalkulator ini membantu trader merencanakan bagian mana dari posisi mereka yang harus ditutup pada level target tertentu untuk mendapatkan rasio pengembalian terhadap risiko terbaik.",
  "cal_milti_Field_req": "bidang harus diisi",
  "cal_milti_accBaseCurr": "Mata Uang Dasar Akun",
  "cal_milti_Symbol": "Simbol",
  "cal_milti_Position_Type": "Jenis Posisi",
  "cal_milti_Buy": "Beli",
  "cal_milti_Sell": "Jual",
  "cal_milti_Open_Price": "Harga Terbuka",
  "cal_milti_Stop_loss_Price": "Harga Stop Loss",
  "cal_milti_trade_size_lot": "Ukuran Perdagangan (dalam lot)",
  "cal_milti_Target_Price": "Harga Target",
  "cal_milti_lots_Clos_Target": "lot Ditutup Sesuai Target",
  "cal_milti_Net_Lot_size": "Ukuran Lot Bersih:",
  "cal_milti_Now": "Hitung Sekarang",
  "cal_milti_Target_Profit": "Target Laba",
  "cal_milti_Total_Profit": "Total Laba",
  "cal_milti_Return_Risk": "Pengembalian Terhadap Risiko",
  "cal_pivot_point_txt": "Fxview menawarkan kalkulator poin pivot untuk membantu Anda mengidentifikasi arah tren yang berlaku dan menentukan level support dan resistance.",
  "cal_pivot_High": "Tinggi",
  "cal_pivot_Low": "Rendah",
  "cal_pivot_Open": "Buka",
  "cal_pivot_Close": "Tutup",
  "cal_pivot_Calculate_Now": "Hitung Sekarang",
  "cal_pivot_Clear": "Jelas",
  "cal_pivot_CLASSIC": "KLASIK",
  "cal_pivot_WOODIE": "WOODIE'S",
  "cal_pivot_CAMARILLA": "CAMARILLA",
  "cal_pivot_DMARKS": "DMARKS'S",
  "cal_pivot_Resistance": "Resistensi",
  "cal_pivot_Pivot_Points": "Poin Pivot",
  "cal_pivot_Support": "Dukungan",
  "cal_pivot_Field_req": "bidang harus diisi",
  "cal_pivot_PivotPoints": "Poin Pivot",
  "cal_profit_Loss": "Laba & Rugi",
  "cal_profitL_Txt": "Kalkulator untung dan rugi Fxview adalah alat bantu dasar yang dapat membantu Anda menghitung untung atau rugi dari suatu perdagangan. Cukup pilih kelas aset, simbol, mata uang dasar akun, harga pembukaan dan penutupan yang diinginkan, jenis posisi dan ukuran perdagangan dalam lot, dan tekan 'Hitung Sekarang'.",
  "cal_profitLField_req": "bidang harus diisi",
  "cal_profitL_accBaseCurr": "Mata Uang Dasar Akun",
  "cal_profitL_Symbol": "Simbol",
  "cal_profitL_Pos_Type": "Jenis Posisi",
  "cal_profitL_Buy": "Beli",
  "cal_profitL_Sell": "Jual",
  "cal_profitL_Open_Price": "Harga Terbuka",
  "cal_profitL_Close_Price": "Harga Penutupan",
  "cal_profitL_trade_size_lot": "Ukuran Perdagangan (dalam lot)",
  "cal_profitL_Now": "Hitung Sekarang",
  "cal_Fibonacci": "Fibonacci",
  "cal_fibo_txt": "Dengan kalkulator fibonacci fxview, Anda bisa menghitung retracements fibonacci berdasarkan titik-titik ekstrem grafik dalam tren naik atau turun. Cukup masukkan nilai tertinggi dan terendah untuk memulai.",
  "cal_fibo_Uptrend": "Uptrend",
  "cal_fibo_Downtrend": "Tren turun",
  "cal_fibo_Field_req": "bidang harus diisi",
  "cal_fibo_High": "Tinggi",
  "cal_fibo_Low": "Rendah",
  "cal_fibo_Now": "Hitung Sekarang",
  "cal_fibo_Retracements": "Penarikan kembali",
  "cal_fibo_Support": "Dukungan",
  "cal_Pip_Value": "Nilai Pip",
  "cal_Pip_txt": "Alat bantu yang efektif untuk mengelola strategi risiko Anda, kalkulator nilai pip kami memungkinkan Anda menghitung nilai per pip dari setiap posisi. Dengan alat ini, Anda bisa memantau risiko setiap trade dengan lebih presisi.",
  "cal_Pip_Field_req": "bidang harus diisi",
  "cal_Pip_accBaseCurr": "Mata Uang Dasar Akun",
  "cal_Pip_Symbol": "Simbol",
  "cal_Pip_trade_size_lot": "Ukuran Perdagangan (dalam lot)",
  "cal_Pip_Now": "Hitung Sekarang",
  "cal_swap": "Tukar",
  "cal_swap_txt": "Swap dapat dianggap sebagai biaya pembiayaan untuk mempertahankan posisi terbuka. Swap dapat bernilai positif atau negatif, dibayarkan/diterima saat posisi tetap terbuka semalaman. Swap berbeda untuk posisi long dan short, dan bervariasi di berbagai instrumen.",
  "cal_swap_MT4_MT5": "MT4/MT5",
  "cal_swap_ACT": "ACT",
  "cal_swap_Field_req": "bidang harus diisi",
  "cal_swap_accBaseCurr": "Mata Uang Dasar Akun",
  "cal_swap_Symbol": "Simbol",
  "cal_swap_Num_Days": "Jumlah Hari",
  "cal_swap_trade_size_lot": "Ukuran Perdagangan (dalam lot)",
  "cal_swap_Swap_Long": ">Tukar Panjang",
  "cal_swap_Swap_Short": "Swap Short",
  "cal_Position_Size": "Ukuran Posisi",
  "cal_position_txt": "Kalkulator ukuran posisi Fxview membantu Anda menghitung berapa banyak lot posisi yang dapat Anda buka, dengan jumlah yang telah ditentukan sebelumnya yang bersedia Anda tanggung risikonya. Cukup tentukan kelas aset, mata uang dasar akun, simbol, jenis posisi, harga terbuka & stop loss, saldo akun, dan persentase risiko (yaitu persentase dari saldo akun Anda yang Anda bersedia mengambil risiko kehilangan), lalu tekan 'Hitung Sekarang'.",
  "cal_position_Field_req": "bidang harus diisi",
  "cal_position_accBaseCurr": "Mata Uang Dasar Akun",
  "cal_position_Symbol": "Simbol",
  "cal_position_Position_Type": "Jenis Posisi",
  "cal_position_BUY": "BELI",
  "cal_position_SELL": "JUAL",
  "cal_position_Open_Price": "Harga Terbuka",
  "cal_position_Account_Balance": "Saldo Rekening",
  "cal_position_Stop_Loss": "Stop Loss",
  "cal_position_Risk_Perc": "Persentase Risiko",
  "cal_position_trade_size_lot": "Ukuran Perdagangan dalam Lot",
  "cal_position_Now": "Hitung Sekarang",
  "cal_curr_Convertor": "Konverter Mata Uang",
  "cal_curr_conv_txt": "Konverter mata uang Fxview memungkinkan pengguna untuk memeriksa nilai satu mata uang terhadap mata uang lainnya berdasarkan nilai tukar saat ini. Dengan konverter mata uang kami, Anda dapat mengonversi dua mata uang apa pun hanya dengan beberapa klik.",
  "cal_curr_conv_From": "Mata uang dari",
  "cal_curr_conv_To": "Mata Uang Ke",
  "cal_curr_conv_Amount": "Jumlah",
  "cal_curr_conv_Field_req": "bidang harus diisi",
  "cal_curr_conv_Now": "Hitung Sekarang",
  "cal_curr_conv_Converted": "Mata Uang yang Dikonversi",
  "cal_leftmenu_commision": "Komisi",
  "cal_leftmenu_margin": "Margin",
  "cal_leftmenu_multiTarget": "Multi-Target",
  "cal_leftmenu_pivotpoints": "Poin Pivot",
  "cal_leftmenu_profitloss": "Laba & Rugi",
  "cal_leftmenu_fibonacci": "Fibonacci",
  "cal_leftmenu_pipValue": "Nilai Pip",
  "cal_leftmenu_Swap": "Tukar",
  "cal_leftmenu_positionSize": "Ukuran Posisi",
  "cal_leftmenu_currencyConv": "Konverter Mata Uang",
  "suppIndex_requestServices": "Dukungan",
  "suppIndex_OpenRequests": "Buka Tiket",
  "suppIndex_ClosedRequests": "Tiket Tertutup",
  "suppReqService_support": "Dukungan",
  "suppReqService_howassist": "Bagaimana kami dapat membantu Anda?",
  "suppReqService_emailus": "Email Kami",
  "suppReqService_email": "info@fxview.com",
  "suppReqService_liveChat": "Obrolan Langsung",
  "suppReqService_avail24": "Tersedia 24/5",
  "suppReqService_requestcallback": "Minta Panggilan Kembali",
  "suppReqService_office": "Kantor: +442031505221",
  "suppReqService_support_phn": "Dukungan: +442031505221",
  "suppReqService_createTicket": "Buat Tiket Dukungan",
  "suppReqService_helpSupport": "Bagaimana kami bisa membantu?",
  "suppReqService_back": "Kembali",
  "suppReqService_AddPaymentMethod": "Tambahkan Metode Pembayaran",
  "ZULU": "ZULU",
  "MQL5": "MQL5",
  "depositBonus": "Bonus Deposit",
  "referfriend": "Referensikan Teman",
  "supp_Wallet": "Dompet",
  "contactReq": "Waktu kontak diperlukan.",
  "support_ticketNumber": "Nomor Tiket",
  "support_reason": "Alasan",
  "support_created": "Tanggal",
  "support_action": "Tindakan",
  "suppview_backToTicket": "Beranda Dukungan",
  "suppview_thankyou": "Terima kasih telah memverifikasi identitas Anda, dan selamat datang di Fxview! Anda sekarang dapat membuka akun trading Live dan mulai trading.",
  "suppview_createliveAcc": "buat akun live",
  "suppview_whilevalidate1": "Saat memvalidasi dokumen bukti alamat Anda, kami melihat bahwa alamat dan nomor identitas yang dimasukkan saat pendaftaran tidak sesuai dengan dokumen yang diunggah saat verifikasi.",
  "suppview_whilevalidate2": "Saat memvalidasi dokumen bukti alamat Anda, kami melihat bahwa alamat yang dimasukkan saat pendaftaran tidak sesuai dengan dokumen yang diunggah saat verifikasi.",
  "suppview_whilevalidate3": "Saat memvalidasi dokumen bukti alamat Anda, kami melihat bahwa nomor identitas yang dimasukkan saat pendaftaran tidak sesuai dengan dokumen yang diunggah saat verifikasi.",
  "suppview_originalAdress": "Alamat asli",
  "suppview_stepMsz18": "Saya tidak ingin mengubah apa pun",
  "suppview_preQues": "Pertanyaan sebelumnya",
  "suppview_nextQues": "Pertanyaan Berikutnya",
  "suppview_stepMsz21": "Menyelesaikan konflik",
  "suppview_idNumEnt": "Nomor ID dimasukkan",
  "suppview_percentComplete": "% Lengkap",
  "suppview_nationalityEntered": "Kebangsaan dimasukkan",
  "suppview_fillone": "Harap isi setidaknya satu kolom",
  "otpVerif_otpVerification": "Verifikasi OTP",
  "otpVerif_otpVerificationText1": "Pin Sekali Pakai telah dikirim ke email Anda.",
  "otpVerif_resendOtpTicket": "Belum menerima email di kotak masuk atau folder spam? Kirim ulang",
  "otpVerif_back": "kembali",
  "otpVerif_backToTicket": "Beranda Dukungan",
  "profileReq_getHelpWith": "Dapatkan Bantuan Dengan",
  "profileReq_Queries": "Pertanyaan Terkait",
  "profileReq_relatedTopics": "Topik Terkait",
  "profileReq_inversterPass": "Jika Anda menghadapi masalah dalam mengatur kata sandi investor dari platform MT4/MT5 Anda, silakan lanjutkan dengan membuat permintaan bantuan",
  "profileReq_notSatisfied": "Saya tidak puas",
  "profileReq_lodgeComplaint": "Kirimkan keluhan",
  "profileReq_helpUsWithYour": "Bantu kami dengan",
  "profileReq_askOtherQuestions": "Ajukan pertanyaan lain kepada kami",
  "profileReq_AddBankDetails": "Tambahkan Detail Bank",
  "profileReq_AddSkrillDetails": "Tambahkan Detail Id Skrill",
  "profileReq_AddNetellerDetails": "Tambahkan Detail Id Neteller",
  "profileReq_AddCreditCardDetails": "Tambahkan Detail Kartu Kredit",
  "profileReq_inn": "di",
  "profileReq_emailHeading": "Silakan masukkan ID email baru Anda di bawah ini",
  "profileReq_exsistsEmailAddress": "Alamat Email yang Ada",
  "profileReq_newEmail": "Masukkan Alamat Email Baru Anda",
  "profileReq_EmailfieldValid": "Masukkan alamat email yang valid",
  "profileReq_EmailfieldReq": "Kolom email harus diisi",
  "profileReq_changeEmailAddress": "Ubah Alamat Email",
  "profileReq_mobileHeading": "Silakan Masukkan Nomor Handphone Baru Anda di bawah ini",
  "profileReq_existingMobileNumber": "Nomor Telepon Seluler yang Ada",
  "profileReq_InvalidNumber": "Nomor Tidak Valid",
  "profileReq_changeMobileNumber": "Ubah Nomor Ponsel",
  "profileReq_postCodeRequired": "Kode pos diperlukan",
  "profileReq_residenceCountryRequired": "Negara tempat tinggal diperlukan",
  "profileReq_uploadRecentAddressProof": "Unggah bukti alamat terbaru",
  "profileReq_docReq": "diperlukan dokumen",
  "profileReq_changeAddress": "Ubah Alamat",
  "profileReq_bankName": "Nama Bank:",
  "profileReq_AccountName": "Nama Akun",
  "profileReq_bankNameRequired": "Nama bank harus diisi",
  "profileReq_accountHolderRequired": "Nama pemegang rekening diperlukan",
  "profileReq_AccNumber": "Nomor Rekening:",
  "profileReq_accountNumberRequired": "Nomor rekening diperlukan",
  "profileReq_country": "Negara",
  "profileReq_countryFieldRequired": "Bidang negara harus diisi",
  "profileReq_IBAN": "IBAN",
  "profileReq_ibanRequired": "Iban diperlukan",
  "profileReq_MyBankNotIBAN": "Bank Saya Tidak Menerbitkan IBAN",
  "profileReq_SwiftCode": "Kode Cepat/BIC/Kode Urut",
  "profileReq_swiftCodeRequired": "Diperlukan kode cepat",
  "profileReq_bankAdd": "Alamat Bank:",
  "profileReq_bankAddressRequired": "Alamat bank diperlukan",
  "profileReq_UpBankStatement": "Unggah Laporan Bank",
  "profileReq_fileallow": "Hanya file jpg, jpeg, png, pdf, docx, doc, xls, xlsx yang diperbolehkan!",
  "profileReq_addNewBank": "Tambahkan Rekening Bank Baru",
  "profileReq_last4Digit": "4 digit terakhir harus diisi dan hanya berisi karakter numerik",
  "profileReq_first4Digit": "4 digit pertama wajib diisi dan hanya berisi karakter numerik",
  "profileReq_frontBack": "Kami memerlukan hal-hal berikut ini untuk verifikasi kartu -",
  "profileReq_frontPhotoCredit": "Salinan berwarna dari sisi depan kartu, yang menunjukkan: nama lengkap, tanggal kedaluwarsa, nama/logo Bank, 4 digit pertama dan 4 digit terakhir dari nomor kartu kredit yang menyembunyikan 8 digit tengah.",
  "profileReq_uploadSupportingDocument": "Unggah Dokumen Pendukung",
  "profileReq_backPhotoCredit": "Salinan berwarna dari sisi belakang kartu yang menyembunyikan kode keamanan CVV. Salinan bagian belakang harus menunjukkan tanda pemegangnya",
  "profileReq_submit": "Kirim",
  "profileReq_paymentRequiredNumeric": "Kolom id pembayaran wajib diisi dan hanya boleh berisi karakter numerik.",
  "profileReq_netSkrill1": "silakan unggah tangkapan layar dari",
  "profileReq_netSkrill2": "profil yang menghubungi nama lengkap,",
  "profileReq_netSkrill3": "id dan alamat. Kami akan mencocokkan nama dan alamat",
  "profileReq_userDetails": "Detail Pengguna",
  "profileReq_ComplaintDetails": "Detail Keluhan",
  "profileReq_employeeWhoOffered": "Karyawan yang menawarkan layanan kepada Klien:",
  "profileReq_timeDisputed": "Tanggal dan Waktu dari situasi yang disengketakan (dalam waktu server MetaTrader):",
  "profileReq_TheDisputeTime": "Waktu sengketa diperlukan",
  "profileReq_ticNoContested": "Nomor tiket dari semua posisi yang diperebutkan dan/atau pending order:",
  "profileReq_DisputedAmount": "Jumlah yang disengketakan:",
  "profileReq_reportComplaint": "Apakah Anda telah melaporkan keluhan Anda kepada Otoritas Pengawas?",
  "profileReq_stateNameAuth": "Mohon sebutkan nama Otoritas Pengawas",
  "profileReq_TheAuthorityName": "Nama otoritas diperlukan",
  "profileReq_DetailedDescript": "Penjelasan rinci tentang Pengaduan:",
  "profileReq_attachTogetherForm": "Mohon lampirkan bersama formulir ini bukti pendukung untuk klaim Anda yang akan memfasilitasi penyelidikan fxview atas keluhan Anda. Bukti pendukung dapat berupa dokumentasi apa pun (tangkapan layar, obrolan, catatan telepon, dll.) yang relevan dengan keluhan Anda.",
  "profileReq_Subject": "Subjek",
  "profileReq_yourMsz": "Pesan Anda",
  "profileReq_ticketHasbeenComplaint": "Keluhan Anda telah berhasil didaftarkan",
  "profileReq_ticketHasbeenCreated": "Tiket Anda telah dibuat",
  "profileReq_proMsz19": "Pergi ke Tiket",
  "profileReq_entervalidcard": "harap masukkan nomor kartu yang valid",
  "profileReq_changeEmail": "Silakan Ubah email saya sesuai rincian berikut ini <br> Email Lama:",
  "profileReq_NEWEmail": "<br> Email Baru :",
  "profileReq_changeMobile": "Silakan Ubah Nomor Ponsel saya sesuai rincian berikut <br> Nomor Lama:",
  "profileReq_newNumber": "<br> Nomor Baru :",
  "profileReq_changebankinfo": "Harap Ubah Informasi Bank saya sesuai rincian berikut <br> Nomor Rekening:",
  "profileReq_holdername": "<br> Nama Pemegang :",
  "profileReq_bankname": "<br> Nama Bank :",
  "profileReq_bankcode": "<br> Kode Bank :",
  "profileReq_sortcode": "<br> Kode Urutkan :",
  "profileReq_bankAddress": "<br> Alamat Bank :",
  "profileReq_changeadress": "Silakan Ubah Alamat saya sesuai dengan rincian berikut ini <br> Alamat1:",
  "profileReq_adresstwo": "<Alamat2:",
  "profileReq_postcode": "<br> Kode Pos :",
  "profileReq_residenceCountry": "<br> Negara Tempat Tinggal :",
  "profileReq_nation": "<br> Kebangsaan :",
  "profileReq_City": "<br> Kota :",
  "profileReq_pleaseAdd": "Silakan Tambahkan",
  "profileReq_paymentmethod": "Metode Pembayaran sesuai rincian berikut <br>",
  "profileReq_number": "Nomor:",
  "profileReq_expiryDate": "<br> Tanggal Kedaluwarsa:",
  "profileReq_id": "Id :",
  "autoscan_AutochartistScanner": "Pemindai AutoChartist",
  "autoscan_IBintegrateAdvancedTool": "AutoChartist adalah perangkat lunak pengenal pola grafik utama yang memindai instrumen trading dan secara otomatis mengenali pengaturan trading berdasarkan breakout, retracements, level support dan resistance sehingga Anda tidak akan pernah melewatkan peluang lagi.",
  "autoscan_closeMt4": "Masuk ke akun MT4 fxview Anda.",
  "autoscan_DownloadRunAuto": "Unduh dan jalankan aplikasi AutoChartist Scanner.",
  "autoscan_SelectPortfoliosTrading": "Pilih fxview MT4 Platform dan lanjutkan dengan instalasi.",
  "autoscan_RestartMt4Platform": "Mulai ulang platform MT4 fxview.",
  "autoscan_autochartistdesc": "Autochartist Scanner dapat digunakan di akun MT4 live dengan deposit minimal $200.",
  "autoscan_DisclaimerAutoChartist": "Penafian: Tulisan di halaman ini dianggap sebagai komunikasi pemasaran dan tidak mengandung, dan tidak boleh ditafsirkan sebagai mengandung, saran investasi atau rekomendasi investasi atau, tawaran atau permintaan untuk transaksi apa pun dalam instrumen keuangan. Kinerja masa lalu bukan merupakan indikasi hasil di masa depan. Mintalah saran independen jika perlu.",
  "autochar_autocharist": "Pembuat Bagan Otomatis",
  "autochar_CreateLiveAccount": "Buat Akun Live",
  "autochar_Cancel": "Batal",
  "subVerf_reqVerify": "Minta Verifikasi",
  "subVerf_dear": "Yang terhormat",
  "subVerf_your": "Anda",
  "subVerf_accountVerMsz1": "permintaan telah berhasil diproses",
  "subVerf_backSubList": "Kembali ke alat susbcription",
  "subtrans_heading": "Detail Transaksi Berlangganan",
  "subtrans_date": "Tanggal (dibuat)",
  "subtrans_payType": "Jenis Pembayaran",
  "subtrans_planprice": "Harga Paket",
  "subtrans_coupon": "Kupon",
  "subtrans_amount": "Jumlah",
  "subtrans_noData": "tidak ada data",
  "subtrans_backVPSlist": "kembali ke daftar VPS",
  "vpsdetail_heading": "Detail VPS",
  "vpsdetail_IPAddress": "Alamat IP",
  "vpsdetail_ServerId": "Id Server",
  "vpsdetail_HostName": "Nama Host",
  "vpsdetail_Disk": "Disk",
  "vpsdetail_Cpu": "Cpu",
  "vpsdetail_Memory": "Memori",
  "vpsdetail_State": "Negara",
  "vpsdetail_Created": "Tanggal",
  "vpsdetail_action": "Tindakan",
  "toolbox_tradeToolbox": "Kotak Peralatan Pedagang",
  "toolbox_moreAboutTradeToolbox": "Cari tahu lebih lanjut tentang Kotak Alat Trader",
  "toolbox_tradeToolMsz1": "Perkaya trading Anda dengan fxview Trader's Tool Box - serangkaian indikator dan aplikasi yang kuat yang menambah kenyamanan dalam perjalanan trading Anda.",
  "toolbox_WhatYouGet": "Apa yang Anda dapatkan",
  "toolbox_TraderToolboxApp": "Aplikasi Kotak Alat Trader",
  "toolbox_TradeTerminal": "Terminal Perdagangan",
  "toolbox_MiniTerminal": "Terminal Mini",
  "toolbox_AlarmsManager": "Manajer Alarm",
  "toolbox_ExcelRTD": "Excel RTD",
  "toolbox_Connect": "Menghubungkan",
  "toolbox_SentimentTrader": "Pedagang Sentimen",
  "toolbox_SessionMap": "Peta Sesi",
  "toolbox_MarketManager": "Manajer Pasar",
  "toolbox_CorrelationMatrix": "Matriks Korelasi",
  "toolbox_CorrelationTrader": "Pedagang Korelasi",
  "toolbox_TickTrader": "Tick Trader",
  "toolbox_StealthOrder": "Pesanan siluman",
  "toolbox_IndicatorPackage": "Paket Indikator",
  "toolbox_Minichart": "Grafik mini",
  "toolbox_PivotPoints": "Poin Pivot",
  "toolbox_HighsLows": "Tertinggi dan Terendah",
  "toolbox_Renkobars": "Renko bar",
  "toolbox_ChartGroup": "Grup Bagan",
  "toolbox_SymbolInfo": "Info Simbol",
  "toolbox_Gravity": "Gravitasi",
  "toolbox_Chart_in_Chart": "Bagan dalam Bagan",
  "toolbox_PeriodConverter": "Konverter Periode",
  "toolbox_Magnifier": "Kaca pembesar",
  "toolbox_OrderHistory": "Riwayat Pesanan",
  "toolbox_FreehandDrawing": "Menggambar dengan tangan bebas",
  "toolbox_BarChanger": "Pengubah Bar",
  "toolbox_KeltnerChannel": "Saluran Keltner",
  "toolbox_DonchianChannel": "Saluran Donchian",
  "toolbox_CandleCountdown": "Hitung Mundur Lilin",
  "toolbox_LinearRegression": "Regresi Linier",
  "toolbox_howtoinstall": "CARA MEMASANG KOTAK ALAT TRADER",
  "toolbox_loginFxViewmt45": "Masuk ke akun fxview MT5 Anda",
  "toolbox_ToolboxApplication": "Unduh dan jalankan aplikasi MT5 Trader's Tool Box",
  "toolbox_FxviewMT45installation": "Pilih Platform MT5 fxview dan lanjutkan dengan instalasi",
  "toolbox_allowDdlImports": "Klik alat> opsi> penasihat ahli> lalu klik ok untuk mengizinkan impor DDL",
  "toolbox_RestartFxviewMT45": "Mulai ulang platform fxview MT5",
  "toolbox_tradeToolboxliveMinDeposit": "Aplikasi Trader's Tool Box dapat digunakan di akun MT5 live dengan jumlah deposit minimal $500.",
  "toolbox_DisclaimerAutoChartist": "Penafian: Tulisan di halaman ini dianggap sebagai komunikasi pemasaran dan tidak mengandung, dan tidak boleh ditafsirkan sebagai mengandung, saran investasi atau rekomendasi investasi atau, tawaran atau permintaan untuk transaksi apa pun dalam instrumen keuangan. Kinerja masa lalu bukan merupakan indikasi hasil di masa depan. Mintalah saran independen jika perlu.",
  "subscription_Subscriptionheading": "Langganan",
  "subscription_SubMsz": "Ambil paket yang Anda inginkan untuk mendapatkan akses ke konten kami dengan mudah, kami ingin menawarkan penawaran lisensi khusus kepada pengguna kami.",
  "subscription_mnth": "/ Bulan",
  "subscription_freeMin": "GRATIS - MIN",
  "subscription_deposit": "Deposito",
  "subscription_Features": "Fitur",
  "subscription_window": "jendela",
  "subscription_Memory": "Memori",
  "subscription_ssdDisk": "DISK SSD",
  "subscription_create": "Membuat",
  "subticket_getSubPlan": "Dapatkan Langganan Untuk Paket ini",
  "subticket_applyCouponCode": "Kode kupon yang diterapkan :",
  "subticket_TotalAmount": "Jumlah Total",
  "subticket_havePromoCode": "Punya Kode Promo?",
  "subticket_deducedMonthlySubscription": "Pilih ID trading dari mana Anda ingin biaya dikurangi untuk langganan bulanan jika persyaratan minimum tidak terpenuhi untuk VPS gratis.",
  "subticket_demo": "Demo",
  "subticket_live": "Langsung",
  "subticket_noteUnsubTool": "Catatan: Pembayaran hanya akan dipotong setelah Anda mengklik berlangganan",
  "subticket_clickToAgree": "Klik Di Sini untuk setuju",
  "subticket_vpsTC": "S&K VPS.",
  "subticket_linkToSub": "Silakan klik tautan tersebut untuk berlangganan.",
  "subticket_subsucce": "telah Berhasil Berlangganan. Untuk mengetahui lebih detail, klik tombol di bawah ini",
  "subticket_AutoChartPage": "Buka Halaman Chartist Otomatis",
  "subticket_controlsignalPage": "Buka Halaman Sinyal Kontrol",
  "subticket_researchReportpage": "Buka Halaman Laporan Penelitian",
  "subticket_currentNewsPage": "Buka Halaman Berita Terkini",
  "subticket_economicCalPage": "Buka Halaman Kalender Ekonomi",
  "subticket_vpsPage": "Buka Halaman VPS",
  "subticket_selectPromoCode": "Pilih Kode Promo",
  "subticket_EnterCouponCode": "Masukkan Kode Kupon",
  "subticket_Apply": "Menerapkan",
  "subticket_For": "Untuk",
  "subticket_noPromoCode": "Anda Belum Memiliki Kode Promo!",
  "subticket_vpsSubPlan": "LANGGANAN PAKET VPS",
  "subticket_createVPS": "Silakan tambahkan dana untuk membuat VPS",
  "subticket_goDepositPage": "Pergi ke halaman deposit",
  "noTradingCreateNewOne": "Belum Ada Akun Trading, Buat Akun Baru",
  "faMszOtp1": "atau bisa juga menggunakan 2fa OTP tetapi Anda harus mengaktifkannya terlebih dahulu dengan mengklik tautan yang diberikan di bawah ini",
  "RESEND_EMAIL": "Kirim Ulang Email",
  "TECH_ERROR": "Kami menghadapi beberapa masalah, silakan coba setelah beberapa waktu",
  "VALIDATION_ERROR": "kesalahan validasi",
  "INVALID_TRADING_ACC": "kesalahan akun perdagangan yang tidak valid",
  "INVALID_WITHDRAWAL_TRANSACTION": "transaksi penarikan yang tidak valid",
  "INVALID_OTP": "OTP tidak valid",
  "FILE_UPLOAD": "Hanya file jpg, jpeg, png, pdf yang diperbolehkan!",
  "OTP_EXPIRED": "OTP kedaluwarsa",
  "OTP_IP_MISMATCH": "OTP tidak cocok",
  "LOW_BALANCE_THEN_AMOUNT": "Jumlah yang Anda masukkan lebih tinggi dari Margin Bebas yang tersedia.",
  "TICKET_EXIST": "tiket sudah ada",
  "EMAIL_EXIST": "email sudah ada",
  "MOBILE_EXIST": "nomor ponsel sudah ada",
  "LOW_BONUS_THEN_AMOUNT": "jumlah yang telah Anda isi rendah maka bonus Anda",
  "INVALID_ACCOUNT_TRANSACTION": "transaksi rekening yang tidak valid",
  "INVALID_TICKET_TRANSACTION": "transaksi tiket yang tidak valid",
  "DEPOSIT_LIMIT": "batas setoran",
  "AMOUNT_GREATER_THEN_ALLOWED": "Jumlah yang Anda masukkan lebih tinggi dari yang diizinkan.",
  "fund_msz": "setoran berhasil",
  "suceessMsz1": "2FA berhasil diaktifkan",
  "suceessMsz2": "2FA berhasil dinonaktifkan",
  "suceessMsz3": "Tautan untuk mengubah kata sandi telah dikirim ke email Anda yang terdaftar",
  "suceessMsz4": "Kata sandi berhasil diubah",
  "suceessMsz5": "Pengiriman ulang OTP berhasil dilakukan",
  "suceessMsz6": "OTP dikirim ke email pendaftaran dan nomor ponsel Anda",
  "suceessMsz7": "Sekarang Anda memenuhi syarat untuk membuka akun live",
  "suceessMsz8": "silakan unggah dokumen Anda dalam waktu 15 hari",
  "suceessMsz9": "berhasil menambahkan nama",
  "suceessMsz10": "Tautan telah dikirim ke email Anda yang terdaftar",
  "suceessMsz11": "berhasil berhenti berlangganan",
  "suceessMsz12": "layanan dimulai ulang dengan sukses",
  "suceessMsz13": "layanan berhasil dinyalakan kembali",
  "suceessMsz14": "layanan berhasil dimatikan",
  "suceessMsz15": "kata sandi layanan berhasil diubah",
  "suceessMsz16": "Tautan telah dikirim ke alamat email Anda yang terdaftar",
  "suceessMsz17": "setoran berhasil",
  "suceessMsz18": "Pengiriman ulang OTP berhasil dilakukan",
  "suceessMsz19": "berhasil menambahkan bank",
  "suceessMsz20": "tiket telah berhasil dibuat dan harap tunggu selama 2-3 hari kerja",
  "suceessMsz21": "Saat ini kami hanya mengizinkan 1.00.000.000. Jika Anda ingin melakukan deposit lebih dari jumlah tersebut, silakan hubungi support",
  "suceessMsz22": "Anda tidak diperbolehkan memasukkan jumlah yang lebih besar dari atau sama dengan batas deposit -, karena Anda belum diverifikasi dan dokumen Anda masih dalam proses verifikasi sehingga Anda tidak dapat melakukan deposit lebih dari 2000 EUR",
  "suceessMsz23": "Jumlah Tidak Valid",
  "suceessMsz24": "Akun Anda tidak diverifikasi",
  "suceessMsz25": "id akun harus berbeda dari id akun lain yang Anda pilih",
  "suceessMsz26": "setidaknya pilih 2 opsi",
  "suceessMsz27": "kata sandi baru tidak sama dengan konfirmasi kata sandi baru",
  "suceessMsz28": "Kata sandi Anda harus terdiri dari setidaknya 6 karakter, dan mencakup setidaknya 1 angka, 1 karakter huruf besar, dan 1 karakter khusus (!@#$%^&*/)",
  "suceessMsz29": "",
  "errorMsz1": "Maaf! Tautan ini telah dihapus. Klik <router-link :to='/lupa-kata sandi'>Di sini</router-link> untuk mengatur ulang lagi!",
  "fxFooterContent": "Finvasia Capital South Africa (PTY) Ltd perusahaan yang terdaftar di Afrika Selatan dengan Nomor Perusahaan 2018/303451/07. Alamat Kantor Terdaftar adalah Lantai 3, 34 Whiteley Blvd, Melrose Arch, Birnam, 2196.",
  "fxMultiRegulated": "Multi-Regulasi",
  "fxAwardWinningBroker": "Pialang Pemenang Penghargaan",
  "fxBestValueBroker": "Pialang Nilai Terbaik",
  "fxForexExpo": "Pameran Forex",
  "fxDubai": "Dubai",
  "fxMostTrustedBroker": "Pialang Paling Tepercaya",
  "fxUltimateFintech": "Fintech Utama",
  "fxCyprus": "Siprus",
  "fxBestGlobalCFDBroker": "Pialang CFD Global Terbaik",
  "fxBestECNSTPBroker": "Pialang ECN/STP Terbaik",
  "fxUFAwardsMEA": "UF memberikan penghargaan kepada MEA",
  "fxBestMultiAssetBroker": "Pialang Multi Aset Terbaik",
  "fxFAME": "FAME",
  "fxSouthAfrica": "Afrika Selatan",
  "fxDontHaveAcc": "Belum memiliki akun?",
  "fxTradingAcc": "Pilih Akun Perdagangan",
  "fxExploreRiskFree": "Jelajahi bebas risiko dengan Akun Demo atau terjun ke pasar riil dengan Akun Live.",
  "fxDemoAccount": "Akun Demo",
  "fxLiveAccount": "Akun Live",
  "fxSubmit": "Kirim",
  "fxPlatform": "Platform",
  "fxAccount": "Akun",
  "fxRawECN": "ECN mentah",
  "fxZeroCommission": "Komisi Nol",
  "fxPremiumECN": "ECN Premium",
  "fxClassic": "Klasik",
  "fxCAD": "CAD",
  "fxCurrencyErr": "Mata uang adalah bidang yang wajib diisi",
  "fxEnterPassword": "Masukkan Kata Sandi",
  "fxBack": "Kembali",
  "fxDOB": "DOB",
  "fxDateofBirth": "Tanggal Lahir",
  "fxAddressDetails": "Detail Alamat",
  "fxEnterAddress": "Masukkan Alamat",
  "fxCity": "Kota",
  "fxCountry": "Negara",
  "fxReportablePerson": "Apakah Anda wajib lapor pajak di Amerika Serikat?",
  "fxYes": "Ya.",
  "fxNo": "Tidak.",
  "fxTINNumber": " Apakah Anda memiliki Nomor Pokok Wajib Pajak (NPWP)?",
  "fxEnterTINnumber": "Masukkan nomor NPWP",
  "fxDOBError": "Tanggal lahir harus dalam format YYYY-MM-DD",
  "fxAddessError": "Kolom address1 wajib diisi.",
  "fxCityError": "Bidang kota diperlukan.",
  "fxTINError": " Kolom Nomor NPWP wajib diisi.",
  "fxpersonalInfo": "Informasi Pribadi",
  "fxFinancialDetails": "Rincian Keuangan",
  "fxCreateLiveAccount": "Buat Akun Live",
  "fxStartTrading": "Mulai Berdagang",
  "fxGoToDashboard": "Buka Dasbor",
  "fxStep1": "Langkah 1",
  "fxStep2": "Langkah 2",
  "fxStep3": "Langkah 3",
  "fxStep4": "Langkah 4",
  "fxSteps": "Langkah",
  "fxOf": "dari",
  "fxStepContent": "Verifikasi cepat tentang status keuangan Anda. Semuanya tentang menjaga lingkungan Anda tetap aman dan terlindungi.",
  "fxPerID": "(Sesuai dengan kartu identitas Anda)",
  "fxWindow": "Windows",
  "fxIOS": "IOS",
  "fxMac": "Mac",
  "fxWeb": "Web",
  "fxTooltip1": "Definisi orang yang wajib melaporkan pajak AS meliputi:",
  "fxTooltip2": "Warga negara atau penduduk AS (termasuk kewarganegaraan ganda),",
  "fxTooltip3": "Orang asing AS (penduduk untuk tujuan pajak)",
  "fxTooltip4": "Seseorang yang lahir di AS?",
  "fxTooltip5": "Seseorang dengan alamat surat atau tempat tinggal di AS saat ini (termasuk kotak pos AS atau alamat yang diurus di AS)",
  "fxTooltip6": "Seseorang yang memiliki nomor telepon AS saat ini",
  "fxTooltip7": "Seseorang dengan instruksi tetap untuk mentransfer dana ke rekening yang dikelola di Amerika Serikat?",
  "fxTooltip8": "Seseorang dengan surat kuasa yang masih berlaku dan efektif atau wewenang penandatanganan yang diberikan kepada orang yang beralamat di AS?",
  "fxTooltip9": "Seseorang yang memiliki visa imigran AS (\"Kartu Hijau\")",
  "fxTooltip10": "Anda dapat menemukan informasi lebih lanjut di internet di alamat ini:",
  "fxTooltip11": "http://www.irs.gov/Businesses/Corporations/Foreign-Account-Tax-Compliance-Act-FATCA",
  "fxFieldRequired": "Bidang ini wajib diisi",
  "fxSelectEdu": "Pilih Kualifikasi Pendidikan",
  "fxEducationQualification": "Kualifikasi Pendidikan",
  "fxIfEmployedSpecify": "Jika Dipekerjakan, Mohon Sebutkan",
  "fxEstimatedAnnualIncome": "Perkiraan Pendapatan Tahunan (USD)",
  "fxSelectAnnualIncome": "Pilih Pendapatan Tahunan",
  "fxEstimatedNetWorth": "Perkiraan Kekayaan Bersih (USD)",
  "fxSelectNetWorth": "Pilih Kekayaan Bersih",
  "fxSelectSourceOfFund": "Pilih Sumber Dana",
  "fxSourceOfFunds": "Sumber Dana",
  "fxQuestion1": "Dalam 2 tahun terakhir, seberapa sering Anda melakukan trading - Forex/CFD, rolling spot Fx, Derivatif, atau instrumen margin trading lainnya?",
  "fxReadDoc": "Saya telah membaca, memahami, dan menerima",
  "fxClientAgreement": "Perjanjian Klien",
  "fxPrivacyPolicy": "Kebijakan Privasi",
  "fxRefundPolicy": "Kebijakan Pengembalian Dana",
  "fxAMLPolicy": "Kebijakan AML",
  "fxRiskDisclosureDocuments": "Dokumen Pengungkapan Risiko",
  "fxComplaintsManagement": "Kerangka Kerja Manajemen Keluhan",
  "fxConflictsInterestManual": "Panduan Konflik Kepentingan",
  "fxPAIAManual": "Manual PAIA",
  "fxAnd": "dan",
  "fxUpfrontDisclosure": "Pengungkapan Dimuka",
  "fxAgree": "Saya setuju data pribadi saya diproses dan disimpan sesuai kebijakan privasi dan untuk fxview",
  "fxSelect": "Pilih",
  "fxOTPText": "PIN sekali pakai telah dikirim ke email Anda. Silakan masukkan di bawah ini untuk memverifikasi email Anda.",
  "fxPlease": "Tolonglah.",
  "fxclickhere": "klik di sini",
  "fxResendOTP": "untuk mengirim ulang PIN satu kali",
  "fxDepositStartTrading": "Deposit & Mulai Trading",
  "fxUploadDocuments": "Unggah Dokumen",
  "fxPremiumECNTooltip": "Tersedia untuk setoran pertama kali sebesar $5000 atau setara",
  "fxTradingID": "ID Perdagangan",
  "fxPassword": "Kata sandi",
  "fxLeverage": "Leverage",
  "fxBaseCurrency": "Mata Uang Dasar Akun",
  "fxDownload": "Unduh",
  "fxPassport": "Paspor",
  "fxDriversLicense": "Surat Izin Mengemudi",
  "fxGovernmentIssuedPhotoID": "Kartu Identitas Foto yang Diterbitkan Pemerintah",
  "fxNext": "Berikutnya",
  "fxWorkingDays": "1 hingga 5 hari kerja",
  "fxBankdetails": "Rincian Bank kami adalah:",
  "fxLessDetail": "Kurang Detail",
  "fxViewDetail": "Lihat Detail",
  "fxMinimumDepositAmount": "Jumlah Setoran Minimum:",
  "fxHolderName": "Nama Pemegang:",
  "fxAccountNumber": "Nomor Rekening:",
  "fxBankName": "Nama Bank:",
  "fxSwiftBIC": "Swift/BIC:",
  "fxIBAN": "IBAN",
  "fxAddress": "Alamat:",
  "fxSortCode": "Sortir Kode",
  "fxReference": "Referensi",
  "fxForTradAccount": "Untuk akun perdagangan",
  "fxNoteSelecting": "*Harap diperhatikan bahwa saat memilih",
  "fxSendFundVia": "Anda mengirim dana melalui",
  "fxNetworkYouDeposit": "jaringan, jika Anda melakukan deposit melalui jaringan lain, aset Anda mungkin hilang.",
  "fxPleaseSelectBank": "Silakan Pilih Bank:",
  "fxSelectBank": "Pilih Bank",
  "fxPleaseSelectCurrency": "Pilih Mata Uang:",
  "fxSelectCurrency": "Pilih Mata Uang",
  "fxWithdrawalWalletAddress": "ALAMAT DOMPET PENARIKAN",
  "fxEnterCryptoAddress": "Masukkan Alamat Kripto",
  "fxIConfirm": "Saya mengonfirmasi, bahwa alamat dompet Crypto yang disebutkan di atas, semata-mata milik saya. Saya mengerti dan saya setuju, bahwa transaksi penarikan di masa depan hanya akan tersedia untuk alamat dompet Crypto ini.",
  "fxAmountBRL": "Jumlah dalam BRL :",
  "fxInvalidCPFNumber": "Nomor CPF tidak valid",
  "fxInOrder": "*Untuk melakukan trading, Anda tetap harus memberikan Bukti Domisili yang valid kepada kami.",
  "fxFollowingDepositPoint": "Saat Anda melakukan deposit, harap perhatikan hal-hal berikut ini:",
  "fxDepositPoint1": "1. Semua transaksi yang dikirim dalam mata uang yang berbeda dengan mata uang akun Anda akan secara otomatis dikonversikan sesuai dengan harga pasar yang berlaku.",
  "fxDepositPoint2": "2. Harap lakukan deposit hanya melalui portal Fxview. Setiap deposit langsung dari dompet Bitcoin Anda dengan faktur yang dibuat sebelumnya tidak akan diproses. Fxview tidak bertanggung jawab dalam kasus tersebut.",
  "fxDepositPoint3": "3. Penarikan akan dikembalikan ke alamat dompet kripto yang sama dengan yang Anda bagikan kepada kami.",
  "fxDepositPoint4": "4. Untuk jumlah deposit/penarikan yang lebih tinggi dari 50.000 USD, Anda mungkin diminta untuk memberikan dokumen tambahan untuk verifikasi dana.",
  "fxDepositPoint5": "5. Setelah melakukan transaksi, harap simpan ID hash Anda agar dana Anda dapat dengan mudah ditemukan jika diperlukan.",
  "fxDepositPoint6": "6. Harap diperhatikan Deposit minimum untuk kripto adalah 10 USD, Jika Anda tidak mematuhi ketentuan ini, aset Anda akan hilang.",
  "fxDepositPoint7": "7. Harap diperhatikan bahwa saat melakukan deposit via mata uang kripto, setiap kali Anda harus membuat alamat deposit baru.",
  "fxCumulativeDeposit": "Setoran kumulatif lebih dari USD 2000 atau yang dilakukan melalui kartu kredit atau debit akan memerlukan",
  "fxVerificationProcess": "proses verifikasi.",
  "fxYourDepositLimit": "Batas Deposit Anda adalah",
  "fxDoWantIncrease": "Apakah Anda Ingin Meningkatkan Limit Deposit Anda",
  "fxEnsure": "Harap pastikan bahwa detail deposit sudah benar dan klik tombol 'Bayar Sekarang' untuk melakukan deposit. Harap diperhatikan bahwa jumlah yang dikonversikan dalam USD/EUR/AUD/GBP/CAD/ZAR dapat bervariasi sesuai dengan nilai tukar yang berlaku.",
  "fxMarketPrice": "harga pasar",
  "fxAmount": "Jumlah",
  "fxCopy": "Salin",
  "fxDone": "Selesai.",
  "fxPayNow": "Bayar Sekarang",
  "fxSendOnly": "Kirim saja",
  "fxDepositAddress": "ke alamat setoran ini",
  "fxTradingAccount": "Kami akan menyetorkannya secara otomatis ke akun trading Anda",
  "fxOnceReceiveMoney": "setelah kami menerima uang",
  "fxBackBonusList": "Kembali ke Daftar Bonus",
  "fxDepositSuccess": "Setoran Berhasil",
  "fxChoosePlatform": "Pilih platform untuk memulai trading:",
  "fxDepositAmount": "Jumlah Setoran",
  "fxPleaseSelectMake": "Pilih Mata Uang yang Anda inginkan untuk melakukan deposit",
  "fxipvValidation1": "Saat memvalidasi dokumen bukti alamat Anda, kami melihat bahwa alamat dan nomor identitas yang dimasukkan saat pendaftaran tidak sesuai dengan dokumen yang diunggah saat verifikasi.",
  "fxipvValidation2": "Saat memvalidasi dokumen bukti alamat Anda, kami melihat bahwa alamat yang dimasukkan saat pendaftaran tidak sesuai dengan dokumen yang diunggah saat verifikasi.",
  "fxipvValidation3": "Saat memvalidasi dokumen bukti alamat Anda, kami melihat bahwa nomor ID yang dimasukkan saat pendaftaran tidak sesuai dengan dokumen yang diunggah saat verifikasi.",
  "fxOriginalAddress": "Alamat asli",
  "fxChangeAnything": "Saya tidak ingin mengubah apa pun",
  "fxProcessing": "Pengolahan.....",
  "fxNoVideoAvailable": "Tidak ada video yang tersedia",
  "fxEngulfingCandlesWebinar": "Menelan Lilin - Webinar",
  "fxDOJICandlesWebinar": "Lilin DOJI- Webinar",
  "fxHaramiCandlesWebinar": "Lilin Harami- Webinar",
  "fxHammerCandlesWebinar": "Lilin Palu- Webinar",
  "fxStarFormations": "Formasi Bintang Pagi- Sore- Webinar",
  "fxVideoTutorials": "Tutorial Video",
  "fxWebinars": "Webinar",
  "fxForexGlossary": "Daftar Istilah Forex",
  "fxAssetClass": "Kelas Aset",
  "fxRiskPercentage": "Persentase Risiko",
  "fxOffersRiskCalculator": "FxView menawarkan kalkulator risiko untuk membantu pengguna dalam mengelola risiko dengan menghitung potensi kerugian maksimum yang dapat ditimbulkan oleh posisi terbuka saat ini dan order tertunda yang aktif.",
  "fxAccountBaseCurrency": "Mata Uang Dasar Akun",
  "fxCurrencyPairs": "Pasangan Mata Uang",
  "fxCryptoCurrencies": "Mata Uang Kripto",
  "fxCurrencies": "Mata uang",
  "fxCommodities": "Komoditas",
  "fxIndices": "Indeks",
  "fxOpenPrice": "Harga Terbuka",
  "fxDealType": "Jenis Kesepakatan",
  "fxBuy": "Beli",
  "fxSell": "Jual",
  "fxStopLoss": "Stop Loss",
  "fxAccountBalance": "Saldo Rekening",
  "fxCalculateNow": "Hitung Sekarang",
  "fxCommisionRoundTrip": "Komisi (perjalanan pulang pergi) : 123.45",
  "fxSegment": "Segmen",
  "fxSymbol": "Simbol",
  "fxVolumeLots": "Volume dalam lot",
  "fxCurrentConversionPrice": "Harga Konversi Saat Ini",
  "fxRiskReward": "Risiko dan Imbalan",
  "fxRiskRewardText": "Kendalikan potensi risiko sebelum memasuki posisi apa pun dengan menggunakan kalkulator risiko dan imbalan kami. Dengan perangkat ini, Anda bisa menghitung target posisi terbaik dan rasio reward dan risiko yang sesuai. Cukup tentukan harga entri, stop loss, dan take profit.",
  "fxZuluAccount": "Akun Zulu Saya",
  "fxCreateZuluAccount": "Buat Akun Zulu",
  "fxMyfxbook": "Myfxbook",
  "fxAutoTrade": "Perdagangan Otomatis",
  "fxMyfxbookText": "Myfxbook AutoTrade adalah platform mirror trading yang memungkinkan Anda menyalin trade dari berbagai sistem trading yang telah teruji dan terbukti sukses di akun live. Untuk menyalin trade, cukup berlangganan sistem trading pilihan Anda.",
  "fxWhyChoose": "Mengapa Memilih",
  "fxMybookAutoTrade": "Myfxbook AutoTrade?",
  "fxDeepAnalysis": "Analisis Mendalam",
  "fxDeepAnalysisText": "Menganalisis berbagai sistem perdagangan secara terperinci berdasarkan kinerja, risiko, dan variabel lainnya",
  "fxTransparency": "Transparansi",
  "fxTransparencyText": "Agar seluruh proses tetap transparan dan efisien, semua data kinerja dibagikan secara terbuka kepada semua orang",
  "fxTestedLiveAcc": "Diuji di Akun Live",
  "fxTestedLiveAccText": "Semua statistik kinerja sistem perdagangan didasarkan pada riwayat perdagangan langsung",
  "fxSetUpMyfxbook": "Bagaimana Cara Mengatur Perdagangan Otomatis Myfxbook",
  "fxSecureClientPortal": "Masuk ke portal klien yang aman, dan jika Anda belum memiliki akun live Myfxbook AutoTrade, buat akun dengan mengeklik `Tambah Akun Trading Baru` > `Akun Live`. Pastikan Myfxbook AutoTrade dipilih sebagai jenis Akun.",
  "fxOnceTheAccount": "Setelah akun dibuat, danai akun Anda dengan $200 atau lebih, dan Anda akan menerima kredensial login AutoTrade melalui email.",
  "fxUseTheseCredentials": "Gunakan kredensial ini untuk masuk ke https://www.fxautotrade.com/ lalu buka `Dashboard` > `Akun Live` > `Fxview` > `Buka Akun Live`. Pada halaman berikutnya, pilih Platform (MT4 atau MT5), Nama Server (Fxview live), Nama Sistem, masukkan ID dan kata sandi akun MT4/MT5 Anda, lalu klik Hubungkan Akun.",
  "fxToConnectToUser": "Untuk menghubungkan ke pengguna, buka tab `Systems`, dan pilih dari berbagai sistem yang dibuat oleh pengguna. Klik pada sebuah sistem untuk melihat statistiknya, dan klik `AutoTrade` untuk menghubungkan.",
  "fxRequestIslamicAccount": "Meminta akun Islami",
  "fxNoteInOrder": "Catatan: Untuk mengonversi akun Anda menjadi Islami, pastikan terlebih dahulu Anda menutup semua posisi terbuka di semua akun trading Anda. Setelah akun Anda dikonversi, Anda tidak akan dapat mengakses akun trading ECN mana pun. Selain itu, akun Islami hanya tersedia di platform trading MT5, jika Anda memiliki saldo di Akun MT5 ECN atau ActTrader, silakan lakukan transfer internal ke dompet Anda.",
  "fxIDoNotHave": "Saya tidak memiliki posisi terbuka di akun trading saya",
  "fxFullRealName": "Nama Asli Lengkap",
  "fxPhoneNumber": "Nomor Telepon",
  "fxGMT": "Waktu Kontak yang Diutamakan (GMT)",
  "fxQuestionComments": "Pertanyaan atau Komentar",
  "fxIslamicAccount": "Rekening Syariah",
  "fxCancelWithdrawalRequest": "Batalkan Permintaan Penarikan Dana",
  "fxDocumentsRejected": "Dokumen Ditolak",
  "fxDocumentsApproved": "Dokumen yang Disetujui",
  "fxDocumentsPending": "Dokumen Tertunda",
  "fxTrackImportant": "Melacak peristiwa dan rilis ekonomi penting yang berdampak pada Forex, Komoditas, Indeks, dan Saham.",
  "fxUpNext": "Berikutnya",
  "fxSelectAll": "Pilih Semua",
  "fxMyFilter": "Filter Saya",
  "fxDefault": "Default",
  "fxClear": "Jelas",
  "fxImpact": "Dampak",
  "fxAll": "Semua",
  "fxMedium": "Sedang",
  "fxHigh": "Tinggi",
  "fxSaveFilter": "Menyimpan pengaturan di filter saya",
  "fxApplyFilter": "Terapkan Filter",
  "fxTimeZoneSettings": "Pengaturan Zona Waktu",
  "fxTimeZone": "Zona Waktu",
  "fxSelectTimeZone": "Pilih Zona Waktu",
  "fxTimeFormat": "Format Waktu",
  "fxAMPM": "AM / PM",
  "fx24Hours": "24 jam",
  "fxSetTimeZone": "Mengatur zona waktu saya secara otomatis",
  "fxSaveSetting": "Simpan Pengaturan",
  "fxCancel": "Batal",
  "fxFrequencyMonthly": "Frekuensi: Bulanan",
  "fxNoRecord": "Tidak ada catatan",
  "fxYouWillReceive": "Anda akan menerima detail login zulu untuk masuk ke portal web ZuluTrade setelah Anda mendanai akun Anda",
  "fxZulu": "Zulu",
  "fxLast": "Terakhir",
  "fxChange": "Perubahan",
  "fxPleaseWaitLoading": "Mohon tunggu pemuatan..",
  "fxAddFunds": "Tambah Dana",
  "fxACT": "ACT",
  "fxUploadDocument": "unggah Dokumen",
  "fxSeeStatus": "Lihat Status",
  "fxMT5DemoWebTrader": "MT5 Demo Web Trader",
  "fxMT5LiveWebTrader": "Trader Web Langsung MT5",
  "fxReferFriend": "Referensikan teman",
  "fxReferedEmail": "Email yang Dirujuk",
  "fxAddMore": "Tambahkan lagi",
  "fxReferNow": "Rujuk Sekarang",
  "fxReferMore": "Rujuk Lebih Lanjut",
  "fxBackToWallet": "Kembali ke Dompet",
  "fxAreYouSureWithdrawal": "Apakah Anda yakin ingin membatalkan permintaan penarikan dana?",
  "fxProceed": "Lanjutkan",
  "fxSelectCryptoAddress": "Pilih Alamat Kripto"
}


// WEBPACK FOOTER //
// ./src/plugins/lang/languages/id.js